<style > 
    .v-calendar .v-event{
        height: auto!important;
        margin-top: 4px;
    }
    .v-list .v-list-item--active{
          color: #0089ffd6!important;
    }
    /* This is for documentation purposes and will not be needed in your application */
    #create .v-speed-dial {
      position: absolute;
    }

    #create .v-btn--floating {
      position: relative;
    }
    .theme--dark.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th{
      color: black;
    }
</style>
<template elevation="8">
  <v-row  class="fill-height" elevation="8"> 
    <v-col >
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <!--<v-btn @click="pdf()"> pdf</v-btn>
          <v-btn class="mr-5" color="primary" dark @click="dialog=true">
              Primer Evento
          </v-btn>
          -<v-btn @click="dialogc=true"><v-icon>print</v-icon></v-btn>-->
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Hoy
          </v-btn>
          <v-btn fab text small color="grey darken-3" @click="prev">
            <span class="material-icons">chevron_left</span>
          </v-btn> 
          <v-btn fab text small color="grey darken-4" @click="next">
            <span class="material-icons">chevron_right</span>
          </v-btn>   
           <v-toolbar-title class="text-capitalize" v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>      
          <v-spacer></v-spacer>
          <v-tooltip bottom v-if="ntarget != 0">
          <template v-slot:activator="{ on, attrs }">
            <v-progress-linear
                v-bind="attrs"
                v-on="on"
                :color="ncolor"
                style="height:100%;width: 200px;margin-right: 8px;"
                :value="PromedioVenta()"
              >
                <span  v-if="ntarget == 0"></span>
                <span v-else>{{parseFloat(PromedioVenta()).toFixed(2)}}%</span>
            </v-progress-linear>
          </template>
          <span >${{addCommas(parseFloat(totalprofit).toFixed(2))}} de ${{addCommas(parseFloat(ntarget).toFixed(2))}}</span>
        </v-tooltip>
          <v-select  class="text-capitalize" v-model="idusuarioselect" v-on:change="getEvents" dense outlined label="Ejecutivos" style="max-width: 250px;margin-top: 20px;" :items="usuarios"></v-select>
        </v-toolbar>
      </v-sheet>
      <v-sheet min-height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          :events="events"
          locale="es-ES"
          :event-color="getEventColor"
          @click:event="showEvent"  
        >
          <template #event="{event}" style="height: auto;width: 95%;margin-bottom: 1px;">
            <v-tooltip top :color=event.colort>
              <template v-slot:activator="{ on, attrs }">
                <div style="padding: 4px;" v-bind="attrs" v-on="on">
                    <v-icon style="font-size: 20px;color: white;margin-right: 5px;">{{event.icon}}</v-icon>
                    <span style="white-space: normal;color:#ffffff;">{{event.name}}</span>
                </div> 
              </template>
              <span>{{event.nactividad}}</span>
            </v-tooltip>             
          </template>
          <v-divider></v-divider>
        </v-calendar>
        <!--Modal de Agregar evento-->
          <v-dialog v-model="dialog"  max-width="400"><!--Primera Actividad-->       
              <v-card class="mx-auto" max-width="400">
                  <v-card-title>
                      <v-icon large left color="#0770c3">
                          phone   
                      </v-icon>
                      <span style="color:#0770c3;" class="title font-weight-bold">Primer Contacto</span>
                  </v-card-title>
                  <v-card-text class="text--primary ">
                      <v-form>
                          <v-select clearable v-model="nombrep" :items="prospectossn" label="*Prospecto">
                          </v-select>
                          <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          max-width="290"
                          dense
                          >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="computedDateFormatpr"
                                clearable
                                label="*Fecha"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="date = null"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                @change="menu = false"
                            ></v-date-picker>
                          </v-menu>                                               
                      </v-form>
                  </v-card-text>
                  <v-card-actions>
                      <v-list-item class="grow">
                          <v-row>
                              <v-list-item-avatar >
                                <span class="material-icons">
                                face
                                </span>
                            </v-list-item-avatar>
                          </v-row>                            
                          <v-row>
                              <v-list-item-content>
                                  <v-list-item-title>{{name()}}</v-list-item-title>
                              </v-list-item-content>
                          </v-row>
                          <v-row align="center" justify="end">
                              <v-btn color="error" text @click="dialog=false">Cancelar</v-btn>
                              <v-btn style="color:#1583da;" dark text @click="guardarPrimeractividad()">Guardar</v-btn>
                          </v-row>
                      </v-list-item>
                  </v-card-actions>
              </v-card>              
          </v-dialog>
          <v-dialog  max-width="900">
            <template>
              <v-card
                class="mx-auto overflow-hidden"
                height="200"
                max-width="900"
              >
                <v-bottom-navigation
                  absolute
                  color="white"
                  hide-on-scroll
                  horizontal
                  scroll-target="#scroll-threshold-example"
                  scroll-threshold="500"
                >
                  <v-btn
                   color="deep-purple accent-4"
                    text>
                    <span>Music</span>
                    <v-icon>visibility</v-icon>
                  </v-btn>
                  <v-btn
                   color="deep-purple accent-4"
                    text>
                    <span>Book</span>
                    <v-icon>create</v-icon>
                  </v-btn>
                  <v-btn
                   color="deep-purple accent-4"
                    text>
                    <span>Image</span>
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-bottom-navigation>
                <v-sheet
                  id="scroll-threshold-example"
                  class="overflow-y-auto pb-16"
                  max-height="600"
                >
                  <v-responsive height="1500">
                    prueba
                  </v-responsive>
                </v-sheet>
              </v-card>
            </template>
          </v-dialog>
          <v-dialog v-model="selectedOpen" max-width="900"
            :close-on-content-click="false"
            scrollable
            :activator="selectedElement"
            offset-x>  
              <v-card            
                min-width="350px"
                class="mx-auto"
              ><!--Reporte de Actividades-->
                <v-toolbar id="create" >
                  <v-row style="width: 100%;align-items: center;">
                    <v-col xs="9" sm="9" md="9" lg="9">
                      <v-row > 
                        <v-col xs="12" sm="12" md="7" lg="7">
                          <v-toolbar-title text-color="#0277BD" >{{selectedEvent.name}}</v-toolbar-title>
                        </v-col>
                        <v-col md="5" lg="5">
                          <v-toolbar-title text-color="#0277BD" >{{NameActividad}}</v-toolbar-title>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col xs="3" sm="3" md="3" lg="3" style="text-align: end;">
                      <!--<v-btn style="color:rgb(17 91 183)" fab text small color="#0277BD darken-3" >
                        <span @click="editarprospecto(selectedEvent.idprospecto)" class="material-icons">create</span>
                      </v-btn>
                      <v-btn style="color:rgb(17 91 183)" fab text small color="#0277BD darken-3" >
                        <span  class="material-icons" @click="editar(selectedEvent.idprospecto)">visibility</span>
                      </v-btn>-->
                      <v-btn style="color:rgb(17 91 183)" icon @click="selectedOpen = false">                  
                        <v-icon>close</v-icon>
                      </v-btn> 
                    </v-col>
                  </v-row>
                </v-toolbar>
                <v-card-text v-model="viewdata" transition="slide-x-transition" v-if="viewdata">
                  <v-spacer></v-spacer>
                  <v-simple-table 
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center">
                            Nombre
                          </th>
                          <th class="text-center">
                            Pais
                          </th>
                          <th class="text-center">
                            Estado
                          </th>
                          <th class="text-center">
                            Tipo de Cuenta
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pros in prospectos" :key="pros.num">
                          <td class="text-center">{{pros.nombre}}</td>
                          <td class="text-center">{{pros.nombrepais}}</td>
                          <td class="text-center">{{pros.nombrepais}}</td>
                          <td class="text-center">{{pros.tio_cuenta}}</td>
                        </tr>
                      </tbody>
                      <thead>
                        <tr>
                          <th class="text-center">
                            Dirección
                          </th>
                          <th class="text-center">
                            Observaciones
                          </th>
                          <th class="text-center">
                            Producto
                          </th>
                          <th class="text-center">
                            Potencial de volumen
                          </th>
                        </tr>
                      </thead>
                      <tbody >
                        <tr  v-for="pros in prospectos" :key="pros.num">
                          <td class="text-center">{{pros.direccion}}</td>
                          <td class="text-center">{{pros.observaciones}}</td>
                          <td class="text-center">{{pros.producto}}</td>
                          <td class="text-center">{{pros.potencialV}}</td>
                        </tr>
                      </tbody>
                      <thead>
                        <tr>
                          <th class="text-center" colspan="2">
                            Origenes
                          </th>
                          <th class="text-center" colspan="2">
                            Destinos
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pros in prospectos" :key="pros.num">
                          <td colspan="2" class="text-center">
                            <v-chip
                              class="ma-2"
                              color="primary"
                            >China</v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                            >Italia</v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                            >Alemania</v-chip>
                          </td>
                          <td colspan="2" class="text-center">
                            <v-chip
                              class="ma-2"
                              color="primary"
                            >Mexico</v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                            >Colombia</v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                            >USA</v-chip>
                          </td>
                        </tr>
                      </tbody>
                      <thead>
                        <tr>
                          <th class="text-center" colspan="2">
                            Tipo de Operación
                          </th>
                          <th class="text-center" colspan="2">
                            Tipo de Transporte
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pros in prospectos" :key="pros.num">
                          <td colspan="2" class="text-center">
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.impo"
                            >
                              Impo
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.expo"
                            >
                              Expo
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.expo"
                            >
                              FCL
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.fcl"
                            >
                              LCL
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.lcl"
                            >
                              FTL
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.ftl"
                            >
                              LTL
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.intermodal"
                            >
                              Intermodal
                            </v-chip>
                          </td>
                          <td colspan="2" class="text-center">
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.maritimo"
                            >
                              Maritimo
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.aereo"
                            >
                              Aereo
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="primary"
                              v-if="pros.terrestre"
                            >
                              Terrestre
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                      <thead>
                        <tr>
                          <th class="text-left" colspan="4">
                            <span>contactos</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="4">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-center">
                                      Nombre
                                    </th>
                                    <th class="text-center">
                                      Puesto
                                    </th>
                                    <th class="text-center">
                                      Telefono
                                    </th>
                                    <th class="text-center">
                                      Celular
                                    </th>
                                    <th class="text-center">
                                      Correo
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in contactosview"
                                    :key="item.nombre"
                                  >
                                    <td class="text-center">{{ item.nombre }}</td>
                                    <td class="text-center">{{ item.puesto }}</td>
                                    <td class="text-center">{{ item.telefono }}</td>
                                    <td class="text-center">{{ item.celular }}</td>
                                    <td class="text-center">{{ item.correo }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
                <v-card-text v-model="hreporte" transition="slide-x-transition" v-if="hreporte"><!--Reporte de Actividades-->
                 <v-dialog 
                  v-model="DialogStarifa"
                  max-width="800px"
                  scrollable
                >
                  <v-card>
                    <v-card-title style="font-size:14px !important;">
                      <span class="text-h5" style="color: #03466e;font-weight: 500;">{{detalleinfo}} # {{nstarifa}}</span>
                    </v-card-title>
                    <v-card-text style="color: #1E1E1E;">
                      <table v-if="viewsta" style="border-collapse: collapse;">
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">ESTATUS:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{nstatus}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">TIPO DE OPERACION</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{noperacion}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">MODALIDAD DE TRANSPORTE:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ntipoembarque}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">TIPO DE EMBARQUE:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{basis}}</td>
                          </tr>
                          <tr v-if="basis === 'FCL' || basis === 'FTL'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">EQUIPO SOLICITADO:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 5px 5px 5px 5px;">
                                  <v-data-table
                                      :headers="headersinfc"
                                      :items="containers"
                                      style="background-color: #FFFFFF;"
                                      class="elevation-1"
                                      >
                                      <template slot="item" slot-scope="containers">
                                          <tr v-if="containers.item.activo == true">
                                              <td style="text-align: center">{{containers.item.quantity}}</td>
                                              <td style="text-align: center">{{containers.item.size}}</td>
                                              <td style="text-align: center">{{containers.item.type}}</td>
                                              <td style="text-align: center">{{containers.item.nweight}}</td>
                                              <td style="text-align: center">{{containers.item.totalweight}}</td>
                                          </tr>
                                      </template>
                                  </v-data-table>  
                              </td>
                          </tr>
                          <tr v-else>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">DESCRICION DE LA CARGA:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 5px 5px 5px 5px;">
                                  <v-data-table
                                      :headers="headerpackageinf"
                                      :items="addpackages"
                                      hide-default-footer
                                      class="elevation-1" 
                                      style="background-color: #FFFFFF;"
                                      >
                                          <template slot="item" slot-scope="addpackages">
                                          <tr v-if="addpackages.item.activo == true">
                                              <td style="text-align: center">{{addpackages.item.quantity}}</td>
                                              <td style="text-align: center">{{addpackages.item.package}}</td>
                                              <td style="text-align: center">{{addpackages.item.nlarge}}</td>
                                              <td style="text-align: center">{{addpackages.item.nwidth}}</td>
                                              <td style="text-align: center">{{addpackages.item.nhigh}}</td>
                                              <td style="text-align: center">{{addpackages.item.nweight}}</td>
                                              <td style="text-align: center">{{addpackages.item.volumetricweight}}</td>
                                              <td style="text-align: center">{{addpackages.item.actualweight}}</td>
                                              <td style="text-align: center">
                                                  <div v-if="addpackages.item.nstackable === 'yes'" style="text-align: center;">
                                                      <v-icon
                                                          small
                                                          class="mr-2"
                                                          style="padding: 4px;border: 1px solid rgb(29, 175, 128);border-radius: 3px;font-weight: 700;"
                                                          color="rgb(29 175 128)"
                                                          >
                                                          check
                                                      </v-icon>
                                                  </div>
                                                  <div v-else style="text-align: center;">
                                                      <v-icon
                                                          small
                                                          class="mr-2"
                                                          style="padding: 4px;border: 1px solid #d80808;border-radius: 3px;font-weight: 700;"
                                                          color="#d80808"
                                                          >
                                                          clear
                                                      </v-icon>            
                                                  </div>                  
                                              </td>
                                          </tr>
                                      </template>
                                  </v-data-table>
                              </td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">INLAND:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ninland}}</td>
                          </tr>
                          <tr v-if="nrecoleccion !=''">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">RECOLECCION:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nrecoleccion}}</td>
                          </tr>
                          <tr v-if="npickup != 'SELECT..'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">PLACE OF RECEIPT/ PICK UP:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{npickup}}</td>
                          </tr>
                          <tr v-if="ntipoembarque === 'FCL' || ntipoembarque === 'LCL' || ntipoembarque === 'AEREO'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">POL / AOL:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{npol}}</td>
                          </tr>
                          <tr v-if="ntipoembarque === 'FCL' || ntipoembarque === 'LCL' || ntipoembarque === 'AEREO'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">POD / AOD:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{npod}}</td>
                          </tr>
                          <tr v-if="ndelivery != 'SELECT..'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">DELIVERY:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ndelivery}}</td>
                          </tr>
                          <tr v-if="nentrega != ''">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;"> ENTREGA:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nentrega}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">MERCANCIA<br>(Descripción general de la carga):</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nmercancia}}</td>
                          </tr>
                          <tr v-if="nfoodgrade != ''">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">FOODGRADE:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nfoodgrade}}</td>
                          </tr>
                          <tr v-if="ncustoms === 'SI'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">DESPACHO ADUANAL:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ncustoms}}</td>
                          </tr>
                          <tr v-if="ninsurance === 'SI'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">SEGURO DE CARGA:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ninsurance}}</td>
                          </tr>
                          <tr v-if="nvgm === 'SI'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">VGM:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nvgm}}</td>
                          </tr>
                          <tr v-if="nmaneuvers === 'SI'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">MANEUVERS:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nmaneuvers}}</td>
                          </tr>
                          <tr v-if="ncustody === 'SI'">
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">CUSTODY:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ncustody}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">HAZARDOUS:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 5px 5px 5px 5px;">{{harz}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">OBSERVACIONES:</td>
                              <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nobservaciones}}</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">COTIZACIONES:</td>
                            <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{ncotizaciones}}</td>
                          </tr>
                        </table>
                        <table v-if="viewcot"  style="border-collapse: collapse;">
                          <tr>
                              <td colspan="2" style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;"><ckeditor   style="color:black;" :editor="editor" v-model="nbody" disabled></ckeditor></td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">MODALIDAD:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{nmodalidad}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">MOVIMIENTO:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{nmovimiento}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">PRODUCTO:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{nproducto}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">ORIGEN:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{norigen}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">DESTINO:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{ndestino}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">SERVICIO:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{nservicio}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">VIA:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{nvia}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">TRANSBORDO:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{ntransbordo}}</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">T.T.:</td>
                              <td style="border: 1px solid;color: black;font-weight: 500;padding: 2px 2px 0px 5px;">{{ntt}}</td>
                          </tr>
                          <tr>
                            <td colspan="4">
                                <v-simple-table style="margin-bottom: 12px;">
                                    <thead>
                                        <tr>
                                            <th>CONCEPTO</th>
                                            <th>COSTO POR:</th>
                                            <th>CANTIDAD</th>
                                            <th>COSTO UNITARIO</th>
                                            <th>MONEDA</th>
                                            <th>SUB TOTAL</th>
                                            <th>IVA</th>
                                            <th>TOTAL</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="det in costos">
                                            <tr v-if="det.activo == true">
                                                <td style="text-align: center;">{{det.concepto}}</td>
                                                <td style="text-align: center;">{{det.costopor}}</td>
                                                <td style="text-align: center;">{{det.cantidad}}</td>
                                                <td style="text-align: center;">{{det.ncostounitario}}</td>
                                                <td style="text-align: center;">{{det.moneda}}</td>
                                                <td style="text-align: center;">{{det.nsubtotal}}</td>
                                                <td style="text-align: center;">{{det.nniva}}</td>
                                                <td style="text-align: center;">{{det.ntotal}}</td>
                                            </tr>
                                        </template>
                                        <tr v-if="activousd == true && MostrarTotal == 1">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td style="text-align: center;">Total USD</td>
                                            <td style="text-align: center;">{{nsubtotalusd}}</td>
                                            <td style="text-align: center;">{{nivausd}}</td>
                                            <td style="text-align: center;">{{ntotalusd}}</td>
                                        </tr>
                                        <tr v-if="activomxn == true && MostrarTotal == 1">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td style="text-align: center;">Total MXN</td>
                                            <td style="text-align: center;">{{nsubtotalmxn}}</td>
                                            <td style="text-align: center;">{{nivamxn}}</td>
                                            <td style="text-align: center;">{{ntotalmxn}}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </td>
                        </tr>
                        <tr v-if="remarksview == true">
                            <td colspan="2">
                                <v-simple-table style="margin-bottom: 12px;">
                                    <thead>
                                        <tr>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="det in remarkstextc" :key="det.num">
                                          <template v-if="det.activo == true">
                                              <td>{{det.text}}</td>
                                          </template>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </td>
                        </tr>
                        </table>
                    </v-card-text>
                  </v-card>
                </v-dialog>     
                  <v-timeline align-top :dense=true>
                    <v-timeline-item 
                      v-for="(item, i) in items"                    
                      :key="i"
                      color="#0277BD"
                      :icon="item.icono"
                      fill-dot
                    >
                      <v-card                       
                        dark                      
                        color="#0277BD"                      
                      >
                        <v-toolbar v-if="item.completada" color="#0277BD">
                          <v-card-title class="title">{{item.nombrea}}</v-card-title>
                          <v-spacer></v-spacer>
                          <span>{{item.fechaactividad1}}</span>                      
                          <v-rating  
                          color="orange"
                          readonly v-model="item.idexpectativa"></v-rating>
                        </v-toolbar>
                        <v-toolbar v-else color="#ea1404">
                          <v-card-title style="heig:auto;" class="title">{{item.nombrea}}</v-card-title>
                          <v-spacer></v-spacer>

                          <v-col sm="3" md="3" lg="3">
                            <v-row style="text-align: center;">
                              <v-col>
                                <span>{{item.fechaactividad1}}</span>
                              </v-col>
                            </v-row>
                          </v-col>                      
                          <v-rating  
                          color="orange"
                          readonly v-model="item.idexpectativa"></v-rating>
                        </v-toolbar>
                        <v-card-text class="white text--primary">
                          <v-row>
                            <v-col v-if="item.iddocumento === 0">
                              <p>{{item.reporte}}</p>
                            </v-col>
                            <v-col v-else>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <a  @click="informacionsolicitud(item.iddocumento,item.clave_actividad)" v-bind="attrs"
                                        v-on="on">{{item.reporte}}
                                        <v-icon
                                            class="mr-2"
                                            dark  color="success"
                                            >
                                            info
                                        </v-icon>
                                      </a>
                                    </template>
                                    <span>Detalles de Solicitud</span>
                                </v-tooltip>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col style="display:flex;border-top: 1px solid #CFD8DC;">
                              <v-list-item-avatar style="margin: 0;color: #546E7A;">
                                <span class="material-icons">
                                face
                                </span>
                            </v-list-item-avatar>
                              <v-list-item-content style="color: #546E7A;">
                                  <v-list-item-title>{{item.nombreus}}</v-list-item-title>
                              </v-list-item-content>
                              <v-spacer></v-spacer>
                              <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">                    
                                      <v-btn icon>
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            @click="AliminarA(item)"
                                            style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"
                                            color="#3d5170"
                                            >
                                            delete_forever
                                        </v-icon>
                                      </v-btn>
                                  </template>
                                  <span>Eliminar</span>
                              </v-tooltip>
                              <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">                    
                                      <v-btn icon>
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            @click="CompletarA(item)"
                                            style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"
                                            color="#3d5170"
                                            >
                                            done
                                        </v-icon>
                                      </v-btn>
                                  </template>
                                  <span>Completar</span>
                              </v-tooltip>
                            </v-col>
                          </v-row>                                     
                        </v-card-text>                      
                      </v-card>
                    </v-timeline-item>
                  </v-timeline>               
                </v-card-text>
                <v-card-text v-model="completar" transition="slide-x-transition" v-if="completar"><!--Completar Actividad-->
                  <v-spacer></v-spacer>
                  <v-row>
                    <v-col style="margin-bottom: 0;" v-if="ncompletada >= 2">
                      <v-checkbox label="Terminar" v-on:change="noviable" v-model="terminaractividad" ></v-checkbox>
                    </v-col>
                  </v-row>                
                  <v-row>                
                        <v-col >
                          <v-select v-on:change="noviable" label="Expectativa" v-model="expectativa" :items="expectativas"></v-select>
                        </v-col>
                        <v-col>
                          <v-select label="Actividad" :disabled="terminaractividad1" v-model="actividad" :items="tactividades"></v-select>
                        </v-col>                  
                        <v-col >
                          <v-menu
                          v-model="fechaa"
                          :disabled="terminaractividad1"
                          :close-on-content-click="false"
                          max-width="290"
                          dense
                          >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="computedDateFormat"
                                clearable
                                label="*Fecha"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="datea = null"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="datea"
                                @change="fechaa = false"
                            ></v-date-picker>
                        </v-menu>  
                        </v-col>
                    <v-col sm="1" md="1" lg="1" v-if="terminaractividad1 == false">
                        <v-btn color="blue" v-if="actvidad2 === false" icon @click="actvidad2 = true"><v-icon>exposure_plus_1</v-icon></v-btn>
                        <v-btn color="red" v-if="actvidad2 === true" icon @click="actvidad2 = false"><v-icon>exposure_neg_1</v-icon></v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="actvidad2 === true">
                      <v-col>
                        <v-select label="Actividad" v-model="actividad2" :items="tactividades"></v-select>
                      </v-col>
                    <v-col>
                      <v-menu
                      v-model="fechaa2"
                      :close-on-content-click="false"
                      max-width="290"
                      dense
                      >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            :value="computedDateFormat2"
                            clearable
                            label="*Fecha"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @click:clear="datea2 = null"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="datea2"
                            @change="fechaa2 = false"
                        ></v-date-picker>
                      </v-menu> 
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea outlined v-model="reporteactividad" label="Reporte"></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row style="border-top: 1px solid rgb(207, 216, 220);">
                    <v-btn text color="error" @click="hreporte=true;completar=false;actvidad2=false">Cancelar</v-btn>
                    <v-btn text style="color:#1583da;" @click="completarActividad()">Guardar</v-btn>                  
                  </v-row>
                </v-card-text>
                <v-card-text v-model="reasignar" v-if="reasignar"><!--Reasignar Actividad-->
                    <v-row style="padding-top: 16px;">
                      <v-col>                    
                        <v-select label="Expectativa" disabled v-model="expectativa2" :items="expectativas"></v-select>
                      </v-col>
                      <v-col>
                        <v-select label="Actividad" v-model="actividadre" :items="tactividades"></v-select>
                      </v-col>                  
                      <v-col>
                          <v-menu
                          v-model="fechaa2"
                          :close-on-content-click="false"
                          max-width="290"
                          dense
                          
                          >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="computedDateFormatr"
                                clearable
                                label="*Fecha"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="dateare = null"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateare"
                                @change="fechaa2 = false"
                            ></v-date-picker>
                          </v-menu>
                      </v-col>
                    </v-row>                  
                    <v-row>
                      <v-col>
                        <v-textarea outlined disabled style="background:#9e9e9e1a;" v-model="reporteactividadn" label="Reporte"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row style="border-top: 1px solid rgb(207, 216, 220);">
                      <v-btn text color="error" @click="hreporte=true;completar=false;actvidad2=false;reasignar=false">Cancelar</v-btn>
                      <v-btn text style="color:#1583da;" @click="agendarActividad()">Guardar</v-btn>                  
                    </v-row>
                </v-card-text>
                <v-card-text v-model="cartap" v-if="cartap"><!--Carta de presentacion-->
                  <v-spacer></v-spacer>
                  <v-row style="padding: 0;height: 80px;">
                    <v-col sm="2" md="2" lg="2" xl="2" style="flex-flow: row-reverse;display: flex;align-items: center;">
                      <span>Para:</span>
                    </v-col>
                    <v-col sm="10" md="10" lg="10" xl="10" style="align-content: center;padding: 0;text-align: center;display: flex;align-items: center;margin-top: 20px;" >
                      <v-combobox
                            v-model="contactoscp"
                            :items="contactosprospecto"
                            :search-input.sync="searcho"
                            hide-selected                                          
                            label="Contactos"
                            multiple
                            persistent-hint
                            small-chips
                            style="margin-left: 8px;"
                            outlined                                       
                            dense
                        >
                            <template v-slot:no-data>
                                <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                    No se encuentran mas contactos"<strong>{{ searcho }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                    </v-list-item-title>
                                </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-combobox>
                    </v-col>
                  </v-row>
                  <v-row style="padding: 0;height: 50px;">
                    <v-col sm="2" md="2" lg="2" xl="2" style="flex-flow: row-reverse;display: flex;padding: 10px;">
                      <span>Asunto:</span>
                    </v-col>
                    <v-col sm="10" md="10" lg="10" xl="10" style="padding: 10px;color: black;align-content: center;padding: 0;display: flex;align-items: center;">
                        <v-text-field v-model="cpasunto" label="asunto" single-line outlined dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="2" md="2" lg="2" xl="2" style="flex-flow: row-reverse;display: flex;padding: 10px;">
                      <span>Adjuntar</span>
                    </v-col>
                    <v-col sm="10" md="10" lg="10" xl="10" style="padding: 10px;color: black;align-content: center;padding: 0;display: flex;align-items: center;">                     
                      <v-combobox
                          outlined
                          dense
                          v-model="adjuntararchivo"
                          :items="archivos"
                          label="Adjuntar Archivos"
                          chips
                          multiple
                          persistent-hint
                          small-chips
                          style="margin-left: 8px;"
                        >
                          <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                    No se encuentran mas archivos"<strong>{{ searcho2 }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                    </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                          </template>
                        </v-combobox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div id="app">
                          <ckeditor :editor="editor" @ready="onReady" v-model="editorcp" style="color:black;border: 1px solid #c1c1c1;"></ckeditor>
                      </div><br>
                    </v-col>
                  </v-row>
                  <v-row style="border-top: 1px solid rgb(207, 216, 220);direction: rtl;">
                    <v-btn text @click="hreporte=true;cartap=false">Cancelar</v-btn>
                    <v-btn text @click="enviarcorreocp()">Enviar</v-btn>
                  </v-row>
                </v-card-text>
                <v-card-text v-model="confirmarVisita" v-if="confirmarVisita" style="padding: 0 70px 20px;"><!--Confirmacion de visita-->
                  <v-row style="align-items: center;">
                    <v-col sm="2" md="2" lg="2" style="text-align: end;">
                      <span style="font-size: 18px;font-weight: 600;color: black;">Para..:</span>
                    </v-col>
                    <v-col sm="10" md="10" lg="10" style="padding: 0;">
                      <v-combobox
                        v-model="contactos"
                        :items="contactosprospecto"
                        :search-input.sync="searcho"
                        hide-selected                                          
                        label="Contactos"
                        multiple
                        persistent-hint
                        small-chips
                        style="margin-left: 8px;"                                           
                        >
                        <template v-slot:no-data>
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                No Se encuentran contactos"<strong>{{ searcho }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                </v-list-item-title>
                            </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-combobox>
                    </v-col>
                  </v-row>
                  <v-row style="align-items: center;">
                    <v-col sm="2" md="2" lg="2" style="text-align: end;">
                      <span style="font-size: 18px;font-weight: 600;color: black;">CC..:</span>
                    </v-col>
                    <v-col sm="10" md="10" lg="10" style="padding: 0;">
                      <v-combobox
                        v-model="contactoscc"
                        hide-selected                                               
                        label="Poner en Copia"
                        multiple
                        persistent-hint
                        small-chips
                        type="mail"                                            
                        >
                        <template v-slot:no-data>
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                presiona <kbd>enter</kbd> para crear uno nuevo
                                </v-list-item-title>
                            </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-combobox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="2" md="2" lg="2" style="text-align: end;">
                      <span style="font-size: 18px;font-weight: 600;color: black;">Asunto:</span>
                    </v-col>
                    <v-col style="padding: 0;">
                      <v-label v-model="asunto" value="UNo" style="font-size: 16px;font-weight: 600;color: black;"><span>Confirmación visita a {{selectedEvent.name}} el día {{datea}}</span></v-label>
                    </v-col>
                  </v-row>
                  <th>
                      <td>
                        <span ><v-img src="@/images/logo OGL.png" max-width="200px" max-height="100"></v-img></span>
                      </td>
                  </th>
                  <v-row>
                      <v-col style="text-align: end;">
                          <span style="font-size: 18px;font-weight: 600;color: black;">CDMX, a {{fechaHoy}}</span>
                      </v-col>
                  </v-row>
                  <v-row style="margin-bottom: 16px;">
                      <v-col><span style="font-size: 18px;font-weight: 400;color: black;">Estimado:</span></v-col>
                  </v-row>
                  <v-row style="margin-bottom: 16px;">
                    <v-col>
                      <span style="font-size: 18px;font-weight: 400;color: black;"> Agradecemos la oportunidad que nos brinda para presentarle personalmente nuestros servicios.</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-bottom: 16px;">
                      <v-col>
                        <v-textarea
                          v-model="contenido"
                          name="input-7-1"
                          value="Me permito confirmar nuestra reunión"
                        ></v-textarea>
                      </v-col>
                  </v-row>
                  <v-row style="margin-bottom: 16px;">
                    <v-col>
                      <span style="font-size: 18px;font-weight: 400;color: black;">
                        Confiamos que nuestra oferta de servicio será la óptima para cubrir sus necesidades y requerimientos.
                      </span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-bottom: 16px;">
                    <v-col style="margin-bottom: 8px;">
                      <span style="font-size: 18px;font-weight: 400;color: black;">Sin más por el momento, agradezco de antemano su amable atención.</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="text-align: end;">                    
                      <v-btn color="primary" @click="enviarcorreoprueba()">Enviar</v-btn>
                      <v-btn color="error" style="margin-left: 8px;">Cancelar</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
          </v-dialog>
          <v-dialog v-model="dialogc" max-width="400"><!--Primera Contacto-->
            <v-card class="mx-auto" max-width="400">
                  <v-card-title>
                      <v-icon large left color="#0770c3">
                          phone   
                      </v-icon>
                      <span style="color:#0770c3;" class="title font-weight-bold">Primer Contacto</span>
                  </v-card-title>
                  <v-card-text class="text--primary ">
                      <div :class="{fullscreen:fullscreen}" class="tinymce-container" :style="{width:containerWidth}">
                        <textarea :id="tinymceId" class="tinymce-textarea">
                          <p></p>
                          <p style="color: rgb(31,73,125);font-weight: 600;margin-bottom: 16px;margin-top: 5px;font-size: 11px;"> Saludos/Best Regards.</p>
                          <p style="color: rgb(31,73,125);font-weight: 600;margin-bottom: 5px;margin-top: 5px;">I.S.C. Alejandro Guerrero</p>
                          <p style="color: rgb(31,73,125);font-weight: 600;margin-bottom: 5px;margin-top: 5px;font-size: 11px;">Sistemas</p>
                          <img src="../assets/logo-co2.png"></img>
                          <p style="color: rgb(31,73,125);font-weight: 600;margin-bottom: 5px;margin-top: 5px;font-size: 11px;">Tel. (+52 55)2455 9630 Ext. 129</p>
                          <p style="color: rgb(31,73,125);font-weight: 600;margin-bottom: 5px;margin-top: 5px;font-size: 11px;">E-mail: alejandro.guerrero@optimagl.com</p>
                          <p style="color: rgb(31,73,125);font-weight: 600;margin-bottom: 5px;margin-top: 5px;font-size: 11px;">Santa Margarita #514, Col. Insurgentes San Borja.</p>
                          <p style="color: rgb(31,73,125);font-weight: 600;margin-bottom: 5px;margin-top: 5px;font-size: 11px;">03100,   CDMX. </p>
                          <p style="color: rgb(31,73,125);font-weight: 600;margin-bottom: 5px;margin-top: 5px;font-size: 11px;">Número D-U-N-S®: 814913794</p>
                          <p style="color: rgb(31,73,125);font-weight: 600;margin-bottom: 5px;margin-top: 5px;font-size: 11px;">As agents only.</p>
                        </textarea>
                      </div>
                  </v-card-text>
            </v-card>
          </v-dialog>
          <v-row justify="center">
              <v-dialog v-model="dialogp" fullscreen hide-overlay transition="dialog-bottom-transition">
                  <template v-slot:activator="{ on }">
                      <!--<v-btn color="primary" dark v-on="on" >Nuevo Prospecto</v-btn>-->
                  </template>
                  <v-card><!--Informacion de Prospectos-->
                      <v-toolbar dark color="light-blue darken-3">
                      <v-btn  icon dark @click="dialogp=false">
                          <v-icon>close</v-icon>
                      </v-btn>
                      <v-toolbar-title class="titulo"><span class="headline">{{ formTitle }}</span></v-toolbar-title>
                      <v-spacer></v-spacer>|
                      <v-toolbar-items>
                          <v-btn dark text @click="guardarprospecto">Guardar</v-btn>
                      </v-toolbar-items>
                      </v-toolbar>
                      <v-form style="background: #f5f5f5;">
                          <v-container>                                    
                              <v-row style="padding-bottom:16px;">
                                  <v-col>
                                      <v-card class="mx-auto">
                                          <v-card-text>
                                              <v-row style="padding: 0px 16px;">
                                                  <v-col>
                                                      <v-row style="align-items: center"><!--Nombre-Pais-Estado-Estatus-->
                                                          <v-col cols="11" sm="11" lg="11" xl="11"  >
                                                              <v-text-field v-model="editprospecto.nombre" append-icon="search" label="Nombre prospecto"></v-text-field>
                                                          </v-col>
                                                          <v-col cols="1" sm="1" md="1" lg="1" xl="1">
                                                              <v-btn><v-icon>search</v-icon></v-btn>
                                                          </v-col>
                                                          <v-col cols="12" sm="4" md="3">
                                                              <v-select v-model="editprospecto.idpais" v-on:change="activarestado" :items="paises" label="País">
                                                              </v-select>
                                                          </v-col>
                                                          <v-col cols="12" sm="4" md="3">
                                                              <v-select v-model="editprospecto.idestado" :items="estados" label="Estado" >
                                                              </v-select>
                                                          </v-col>
                                                          <v-col>
                                                              <v-select v-model="editprospecto.idestatus" :items="estatus" label="Estatus">
                                                              </v-select>
                                                          </v-col>
                                                          <v-col>
                                                              <v-select v-model="editprospecto.tio_cuenta" :items="tcuentas"  label="Tipo de cuenta">                                                                    
                                                              </v-select>                                            
                                                          </v-col>
                                                      </v-row>
                                                      <v-row><!--Direccion-Producto-PotencialV-Industria-->
                                                          <v-col cols="12" sm="6" md="4">
                                                              <v-textarea outlined   v-model="editprospecto.direccion" label="Dirección"></v-textarea>
                                                          </v-col>
                                                          <v-col>
                                                              <v-textarea outlined   v-model="editprospecto.observaciones" label="Observaciones"></v-textarea>
                                                          </v-col>
                                                          <v-col cols="12" sm="12" md="4">
                                                              <v-row>
                                                                  <v-col cols="12" md="12" lg="12">
                                                                      <v-text-field v-model="editprospecto.producto" style="padding-top: 0px; margin-top: 0px;" label="Producto"></v-text-field>
                                                                  </v-col>                                                
                                                              </v-row>
                                                              <v-row>
                                                                  <v-col cols="12" md="12" lg="12">
                                                                      <v-text-field v-model="editprospecto.potencialV" style="padding-top: 0px; margin-top: 0px;" label="Potenial de volumen"></v-text-field>
                                                                  </v-col>
                                                              </v-row>
                                                              <v-row>
                                                                  <v-col cols="12" md="12" lg="12">
                                                                      <v-text-field v-model="editprospecto.industria" style="padding-top: 0px; margin-top: 0px;" label="Industria"></v-text-field>
                                                                  </v-col>  
                                                              </v-row>
                                                          </v-col>                                       
                                                      </v-row>
                                                  </v-col>
                                              </v-row>                                                    
                                          </v-card-text>
                                      </v-card>
                                  </v-col>
                              </v-row>
                              <v-spacer></v-spacer>
                              <v-row justify="space-around"><!--Tipo de Operacion-..-->
                                  <v-col md="6">
                                      <v-card class="mx-auto" style="height: 256px;">
                                            <v-list-item two-line>
                                              <v-list-item-content style="padding-bottom: 0;">                                                         
                                                  <v-toolbar flat color="white">
                                                      <v-row>
                                                          <v-col>
                                                              <v-toolbar-title>Tipo de operación</v-toolbar-title>
                                                          </v-col>
                                                          <v-col style="display: contents;">
                                                              <v-btn v-model="BtnCheck" @click="checkall=true,allcheck()" style="background-color: transparent;">
                                                                  <v-checkbox v-model="checkall"  hide-details></v-checkbox>
                                                                  <span>ALL</span>
                                                              </v-btn>
                                                          </v-col>
                                                      </v-row>
                                                  </v-toolbar>
                                                  <v-divider
                                                      class="mx-4"
                                                      inset                                                            
                                                      ></v-divider>                                                                                                                                                                            
                                              </v-list-item-content>
                                          </v-list-item>
                                          <v-card-text style="padding-top: 0;">
                                              <v-row style="padding: 1px 10px;">                                                 
                                                  <v-col>
                                                      <v-checkbox v-model="editprospecto.impo" label="Impo"></v-checkbox>
                                                  </v-col>
                                                  <v-col>
                                                      <v-checkbox v-model="editprospecto.expo"   label="Expo"></v-checkbox>
                                                  </v-col>
                                                  <v-col>
                                                      <v-checkbox v-model="editprospecto.fcl" label="FCL"></v-checkbox>
                                                  </v-col>
                                                  <v-col>
                                                      <v-checkbox v-model="editprospecto.lcl" label="LCL"></v-checkbox>
                                                  </v-col>
                                                  <v-col>
                                                      <v-checkbox v-model="editprospecto.ftl" label="FTL"></v-checkbox>
                                                  </v-col>
                                                  <v-col>
                                                      <v-checkbox v-model="editprospecto.ltl" label="LTL"></v-checkbox>
                                                  </v-col>
                                                  <v-col>
                                                      <v-checkbox v-model="editprospecto.intermodal" label="Intermodal"></v-checkbox>
                                                  </v-col>
                                              </v-row>
                                          </v-card-text>
                                      </v-card>                                                                                                  
                                  </v-col>
                                  <v-col>
                                      <v-card class="mx-auto" style="height: 256px;">
                                      <v-row>
                                          <v-col>                                                    
                                              <v-list-item two-line>
                                                  <v-list-item-content style="padding-bottom: 0;">                                                        
                                                      <v-toolbar flat color="white">
                                                          <v-row>
                                                              <v-col>
                                                                  <v-toolbar-title>Modalidad de transporte</v-toolbar-title>
                                                              </v-col>
                                                              <v-col style="display: contents;">
                                                                  <v-btn v-model="BtnCheck2" @click="checkall2=true,allcheck2()" style="background-color: transparent;">
                                                                      <v-checkbox v-model="checkall2"  hide-details></v-checkbox>
                                                                      <span>ALL</span>
                                                                  </v-btn>
                                                              </v-col>
                                                          </v-row>                                                             
                                                      </v-toolbar>
                                                      <v-divider class="mx-4" inset ></v-divider>
                                                  </v-list-item-content>
                                              </v-list-item>
                                              <v-card-text style="padding-bottom: 0; padding-top: 0;">  
                                                  <v-row>
                                                      <v-col>
                                                          <v-checkbox v-model="editprospecto.maritimo" label="Marítimo"></v-checkbox>
                                                      </v-col>
                                                      <v-col>
                                                          <v-checkbox v-model="editprospecto.aereo" label="Aéreo"></v-checkbox>
                                                      </v-col>
                                                      <v-col>
                                                          <v-checkbox v-model="editprospecto.terrestre" label="Terrestre"></v-checkbox>
                                                      </v-col>
                                                  </v-row>
                                              </v-card-text>
                                          </v-col>
                                      </v-row>
                                      <v-row>
                                          <v-col>
                                              <v-textarea
                                              outlined                                                    
                                              v-model="editprospecto.zona"
                                              label="Zona"
                                              style="padding: 0 16px;"                                                    
                                              ></v-textarea>
                                          </v-col>
                                      </v-row>                                      
                                      </v-card>                                                                                        
                                  </v-col>                                       
                              </v-row>
                              <v-row style="padding:16px;">
                                  <v-col> <!-- Origen -->
                                      <v-combobox
                                          v-model="origenes"
                                          :items="paises"
                                          :search-input.sync="searcho"
                                          hide-selected                                               
                                          label="Orígenes"
                                          multiple
                                          persistent-hint
                                          small-chips                                                
                                          >
                                          <template v-slot:no-data>
                                              <v-list-item>
                                              <v-list-item-content>
                                                  <v-list-item-title>
                                                  No hay resultados que coincidan "<strong>{{ searcho }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                                  </v-list-item-title>
                                              </v-list-item-content>
                                              </v-list-item>
                                          </template>
                                      </v-combobox>
                                  </v-col>
                                  <v-col> <!-- Destino -->
                                      <v-combobox
                                          v-model="destinos"
                                          :items="paises"
                                          :search-input.sync="searchp"
                                          hide-selected                                               
                                          label="Destinos"
                                          multiple
                                          persistent-hint
                                          small-chips                                                
                                          >
                                          <template v-slot:no-data>
                                              <v-list-item>
                                              <v-list-item-content>
                                                  <v-list-item-title>
                                                  No hay resultados que coincidan "<strong>{{ searchp }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                                  </v-list-item-title>
                                              </v-list-item-content>
                                              </v-list-item>
                                          </template>
                                      </v-combobox>
                                  </v-col>
                              </v-row>
                              <v-row><!--Contactos-->
                                  <v-col cols="12">
                                      <v-card class="mx-auto">
                                            <v-list-item two-line>
                                              <v-list-item-content>                                                        
                                                  <v-toolbar flat color="white">
                                                      <v-toolbar-title>Contactos</v-toolbar-title>
                                                      <v-divider
                                                      class="mx-4"
                                                      inset
                                                      vertical
                                                      ></v-divider>
                                                      <v-spacer></v-spacer>                                                                    
                                                  </v-toolbar>                                                              
                                                  <v-list-item-subtitle>* Campos obligatorios</v-list-item-subtitle>
                                              </v-list-item-content>
                                          </v-list-item>
                                          <v-card-text style="padding-top: 0; padding-bottom: 0;">                                                    
                                              <v-row align="center">
                                                  <v-col md="6">
                                                      <v-text-field v-model="editcontact.nombre" label="*Nombre contacto"></v-text-field>
                                                  </v-col>
                                                  <v-col sm="6" md="3">
                                                      <v-text-field v-model="editcontact.puesto" label="Puesto"></v-text-field>
                                                  </v-col>
                                                  <v-col sm="6" md="3">
                                                      <v-text-field v-model="editcontact.telefono" label="Teléfono"></v-text-field>
                                                  </v-col>
                                                  <v-col>
                                                      <v-text-field v-model="editcontact.celular" label="Celular"></v-text-field>                                                            
                                                  </v-col>
                                                  <v-col >
                                                      <v-text-field v-model="editcontact.correo" label="*Correo"></v-text-field>
                                                  </v-col>                                                        
                                              </v-row>    
                                              <v-row>
                                                  <v-col style="display: flex;flex-direction: row-reverse;margin-bottom: 10px;">
                                                      <v-btn small color="primary" @click="agregar" dark>Agregar</v-btn>
                                                  </v-col>
                                              </v-row>                                                 
                                              <v-row>
                                                  <v-col  style="padding-bottom: 10px;">
                                                      <v-data-table
                                                      :headers="headers"
                                                      :items="contactos"
                                                      sort-by="calories"
                                                      class="elevation-1"
                                                      >
                                                      <template v-slot:item.activo="{ item }">  
                                                          <div v-if="item.activo">
                                                              <span class="blue--text">Activo</span>                
                                                          </div>
                                                          <div v-else>
                                                              <span class="red--text">Inactivo</span>                
                                                          </div>                  
                                                      </template>
                                                      <template v-slot:item.opciones="{ item }">
                                                                  <v-icon
                                                                  small
                                                                  class="mr-2"
                                                                  @click="editItemc(item)"
                                                                  style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                  color="#3d5170"
                                                                  >
                                                                  edit
                                                                  </v-icon>
                                                                  <template v-if="item.activo">
                                                                      <v-icon
                                                                          small
                                                                          class="mr-2"
                                                                          @click="activarDesactivarMostrar(2,item)"
                                                                          style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                          color="#3d5170"
                                                                          >
                                                                          delete
                                                                          </v-icon>                               
                                                                  </template>                                                             
                                                      </template>     
                                                          <template v-slot:no-data>
                                                              <v-btn color="primary" @click="initialize">Reset</v-btn>
                                                          </template>
                                                      </v-data-table>                                                            
                                                  </v-col>
                                              </v-row>                                                    
                                          </v-card-text>                                                
                                      </v-card>
                                  </v-col>
                              </v-row>
                              <v-divider></v-divider>  
                              <v-row>
                                  <v-col style="text-align: center;" >
                                      <v-btn style="margin:12px; color:white;" @click="guardarprospecto"  color="light-blue darken-4">Guardar</v-btn>
                                        <v-btn style="margin:12px; color:white" color="red darken-4" @click="dialog=false">Cancelar</v-btn>
                                  </v-col>                                        
                              </v-row>
                          </v-container>
                      </v-form>                           
                  </v-card>
              </v-dialog>                    
          </v-row>
      </v-sheet>
      <v-dialog
          v-model="dialodload"
          hide-overlay
          persistent
          width="300"
      >
          <v-card 
          color="primary"
          dark
          >
              <v-card-text><br>
                  Please stand by
              <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
              ></v-progress-linear>                    
              </v-card-text>
          </v-card>
      </v-dialog>
       <!--Cuadro de mensajes-->
      <v-snackbar
        v-model="snackbar"
        bottom
        color="info"                
        :timeout = 2000
        top
        vertical
        >
          {{ text }}
          <template >
              <v-btn dark text @click="snackbar = false">
                  Close
              </v-btn>
          </template>
      </v-snackbar>
      <template>
        <div class="vld-parent">
          <loading
          :active.sync="isLoading" 
          :can-cancel="true" 
          :on-cancel="onCancel"
          :is-full-page="fullPage" 
          ></loading>
        </div>
      </template>
      <template>
        <loader object="#33b1ff" color1="#96d5fd" color2="#0178df" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="circular"></loader>
      </template>
    </v-col>
  </v-row>
</template>

<script>

import axios from 'axios' 
import jsPDF from 'jspdf'
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

Vue.use(Loading);

  export default {
    computed: {
      activeFab () {
        switch (this.tabs) {
          case 'one': return { class: 'purple', icon: 'more_vert' }
          case 'two': return { class: 'red', icon: 'more_vert' }
          case 'three': return { class: 'green', icon: 'more_vert' }
          default: return {}
        }
      }
    },
    name: 'app',
    data(){
      return{
        nbody:'',
        nmodalidad:'',
        nmovimiento:'',
        nproducto:'',
        norigen:'',
        ndestino:'',
        nservicio:'',
        nvia:'',
        ntransbordo:'',
        ntt:'',
        viewsta:false,
        viewcot:false,
        MostrarTotal:false,
        nscolor:'',
        ncotizaciones:'',
        nstarifa:'',
        DialogStarifa:false,
        nmercancia:'',
        nobservaciones:'',
        harz:'',
        ncustody:'',
        nmaneuvers:'',
        nvgm:'',
        ncustoms:'',
        ninsurance:'',
        nfoodgrade:'',
        npol:'',
        npod:'',
        nrecoleccion:'',
        npickup:'',
        ndelivery:'',
        nentrega:'',
        ntipoembarque:'',
        basis:'',
        noperacion:'',
        nstatus:'',
        starifa:[{
          status:'',
        }],
        loadingS:true,
        dialodload:false,
        reporteactividadn:'',
        expectativa2:'',
        actividadre:'',
       // title:'',
        dialogp:false,
        viewdata:false,
        editorcp:'',
        editor: DecoupledEditor,
        hasChange: false,
        hasInit: false,
        tinymceId: this.id,
        fullscreen: false,
        languageTypeList: {
          'en': 'en',
          'zh': 'zh_CN',
          'es': 'es_MX',
          'ja': 'ja'
        },
        isLoading: false,
        fullPage: true,
        dialogc:false,
        adjuntararchivo:'',
        archivos:[],
        contactos2:'',
        NameActividad:'',
        menuactividad:false,
        terminaractividad:false,
        actvidad2:false,
        toggle_exclusive: 2,
        toggle_multiple: [],
        confirmarVisita:false,
        on:'',
        attrs:'',
        date:'',
        datea2:'',
        dateare:'',
        today:'',
        hreporte:true,
        completar:false,
        reasignar:false,
        rating:'',
        menu:false,
        fechaa:false,
        fechaa2:false,
        title:'',
        text:'',
        idactividad:'',
        idprospecto:'',
        prospectossn:[],
        nombrep:'',
        fechaactividad:'',
        focus: '',
        type: 'month',
        typeToLabel: {
          month: 'Month',
          week: 'Week',
          day: 'Day',
          '4day': '4 Days',
        },
        start: null,
        end: null,
        icon:'',
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        nombre:null,
        nombreu:[],
        idnombreu:'',
        reporte:'',
        fecha:'',
        color:'',
        eventos:[],
        detalle:null,
        dialog:false,
        snackbar:false,
        currentlyEditing:false,
        items: [        
        ],
        expectativas:[],
        tactividades:[],
        reporteactividad:'',
        expectativa:'',
        datea:'',
        cartap:false,
        //////////////////////////////////
        chips: [],
        itemscon: ['Streaming', 'Eating'],
        colorActividad:'',
        actividadinactiva:false,
        idactividadpendiente:'',
        clientependiente:'',
        fehaactividad:null,
        numactividad:0,
        fechastar:null,
        Numcompletar:0,
        ncompletada:0,
        hoy:'',
        ncustumer:'',
        contenido:'',
        ///
        searcho:'',
        contactos:[],
        contactosprospecto:[],
        Copia:[],
        asunto:'',
        asunto2:'',
        contactoscc:'',
        contactoscp:'',
        cpasunto:'',
        contenidocp:'',
        fechaHoy:'',
        primera:false,
        segunda:false,
        terminaractividad1:false,
        diasSemana: new Array("Lunes","Martes","Miércoles","Jueves","Viernes","Sábado","Domingo"),
        idasignacion:0,
        /**------------- */
        transition: 'slide-y-reverse-transition',
        hover:false,
        fab: false,
        fling: false,
        tabs: null,
        direction: 'bottom',
        /*-------------*/
        prospectos:[],
        contactosview:[],
        editprospecto:{
            idprospecto:'',
            nombre:'',
            idpais:'',
            idestado:{text:'Select',value:'34'},
            idciudad:'',
            idestatus:'',
            direccion:'',
            producto:'',
            potencialV:'',
            industria:'',
            observaciones:'',
            zona:'',
            tio_cuenta:'',
            impo:'',
            expo:'',
            fcl:'',
            lcl:'',
            ltl:'',
            ftl:'',
            intermodal:'',
            maritimo:'',
            aereo:'',
            terrestre:'',
            asignacion:'',
            activo:'',
        },
        editcontact:{
            idcontacto:'',
            nombre:'',
            puesto:'',
            telefono:'',
            celular:'',
            correo:'',            
        },
        editedIndexp:-1,
        editprospectos:[],
        /**********************/
        paises:[],
        estados:[],
        estatus:[],
        tcuentas:['A','AA','AAA','VIP'],
        BtnCheck:'',
        BtnCheck2:'',
        checkall:false,
        checkall2:false,
        origenes:[],
        destinos:[],
        searchp:'',
        headers: [
            { text: 'OPCIONES', value: 'opciones', sortable: false },        
            { text: 'NOMBRE', value: 'nombre' },
            { text: 'PUESTO', value: 'puesto' },
            { text: 'TELÉFONO', value: 'telefono' },
            { text: 'CELULAR', value: 'celular' },
            { text: 'CORREO', value: 'correo', sortable: false },
            { text: 'ESTADO', value: 'activo' },
        ],
        usuarios:[],
        idusuarioselect:0,
        ntarget:0,
        finicio:null,
        ffin:null,
        ncolor:'',
        totalprofit:0,
        addpackages:[],
        headerpackageinf:[
            {text:'Quantity',value:'quantity',align:'center',sortable:false},
            {text:'Package',value:'package',align:'center',sortable:false},
            {text:'Lenth',value:'nlarge',align:'center',sortable:false},
            {text:'Width',value:'nwidth',align:'center',sortable:false},
            {text:'Height',value:'nhigh',align:'center',sortable:false},
            {text:'Weight',value:'nweight',align:'center',sortable:false},
            {text:'Volumetric weight',value:'volumetricweight',align:'center',sortable:false},
            {text:'Actual weight',value:'actualweight',align:'center',sortable:false},
            {text:'Stackable',value:'nstackable',align:'center',sortable:false},
        ],
        ninland:'',
        containers:[],
        headersinfc: [    
          { text: 'Quantity', value: 'quantity',align:'center',sortable:false },
          { text: 'Size', value: 'size',align:'center' ,sortable:false},
          { text: 'Type', value: 'type',align:'center' ,sortable:false},
          { text: 'Weight', value: 'nweight',align:'center' ,sortable:false},
          { text: 'Total Weight', value: 'totalweight',align:'center' ,sortable:false},
        ],
        Masa:[],
        Longitud:[],
        /***********Tarifa********/
        costos: [],
        subtotalusd: 0,
        ivausd: 0,
        totalusd: 0,
        nsubtotalusd: 0,
        nivausd: 0,
        ntotalusd: 0,
        subtotalmxn: 0,
        ivamxn: 0,
        totalmxn: 0,
        nsubtotalmxn: 0,
        nivamxn: 0,
        ntotalmxn: 0,
        activousd:false,
        activomxn:false,
        /************Observaciones Cotizacion**********/
        remarkstextc:[],
        RemarksCotizacion:[],
        remarksview:false,
        detalleinfo:'',
      }
    },
    watch: {
      top (val) {
        this.bottom = !val
      },
      right (val) {
        this.left = !val
      },
      bottom (val) {
        this.top = !val
      },
    },
    computed: {
      formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndexp === -1 ? 'Ingresar Información de Prospecto' : 'Actualizar información de prospecto'
      },
      containerWidth() {
        const width = this.width
        if (/^[\d]+(\.[\d]+)?$/.test(width)) { // matches `100`, `'100'`
          return `${width}px`
        }
        return width
      },
      computedDateFormat()  {
        return this.formatDate1(this.datea)
      },
      computedDateFormat2() {
        return this.formatDate1(this.datea2)
      },
      computedDateFormatr() {
        return this.formatDate1(this.dateare)
      },
      computedDateFormatpr(){
        return this.formatDate1(this.date)
      },
      title () {
        const { start, end } = this
        if (!start || !end) {
          return ''
        }

        const startMonth = this.monthFormatter(start)
        const endMonth = this.monthFormatter(end)
        const suffixMonth = startMonth === endMonth ? '' : endMonth

        const startYear = start.year
        const endYear = end.year
        const suffixYear = startYear === endYear ? '' : endYear

        const startDay = start.day + this.nth(start.day)
        const endDay = end.day + this.nth(end.day)

        switch (this.type) {
          case 'month':
            return `${startMonth} ${startYear}`
          case 'week':
          case '4day':
            return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
          case 'day':
            return `${startMonth} ${startDay} ${startYear}`
        }
        return ''
      },
      monthFormatter () {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC', month: 'long',
        })
      },
    },
    mounted () {
      //this.init()
      this.$refs.calendar.checkChange()    
      this.fechahoy();  
    },
    created () {        
      //  this.listar();
        this.select();  
        this.cargarremarks();      
    },
    components: {
      Loading
    },
    methods: {
      pdf(){
        let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        axios.get('api/Actividades/CreatePdf',configuracion).then(function(response){
        }).catch(function(error){
          console.log(error);
        });
      },
      editar(id){
        this.hreporte = false;
        this.viewdata = true;
        let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        axios.get('api/Prospectos/Buscar/'+id,configuracion).then(function(response){
          me.prospectos=response.data;                
          me.listarContacto(id)
        }).catch(function(error){
          console.log(error);
        });
      },
      onReady( editor )  {
          // Insert the toolbar before the editable area.
          editor.ui.getEditableElement().parentElement.insertBefore(
              editor.ui.view.toolbar.element,
              editor.ui.getEditableElement()
          );
      },
      onCancel() {
        console.log('User cancelled the loader.')
      },
      formatDate1(date){
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      crearPDF(){
        var columns =[
          {title:"ID", dataKey:"id"},
          {title:"Name",dataKey:"name"},
          {title:"Country",dataKey:"country"},
          {title:"Region",dataKey:"region"}
        ];
        var rows=[
          {"id":1,"name":"Shaw","country":"Tanzania","region":"5412"},
          {"id":2,"name":"Shaw","country":"Tanzania","region":"5412"},
          {"id":3,"name":"Shaw","country":"Tanzania","region":"5412"},
          {"id":4,"name":"Shaw","country":"Tanzania","region":"5412"},
          {"id":5,"name":"Shaw","country":"Tanzania","region":"5412"}
        ];

        var doc = new jsPDF('p','pt');
        doc.autoTable(columns, rows,{
          styles:{fillcolor:[100,255,255]},
          columnStyle:{
            id:{fillcolor:255}
          },
          margin:{top:60},
          addPageContent:function(data){
            doc.text("Listado de Actividades",40,30);
          }
        });
        doc.save("table.pdf");

      },      
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      select(){//mandamos llamar el controlador Puertos y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
                let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                var expectativa=[];
                var tactividad=[];
                var cartas=[];
                var paisesArray=[];
                var estadosArray=[];
                var estatusArray=[];
                var usuariosarray = [];
                var masaArray = [];
                var longitudArray = []; 
                
                axios.get('api/Unidadmedidalongitudes/Select',configuracion).then(function(response){            
                longitudArray=response.data;
                longitudArray.map(function(x){
                    me.Longitud.push({text:x.nombre,value:x.idunidad,idclave:x.idclave});
                  });
                }).catch(function(error){
                    console.log(error);
                });
                axios.get('api/Unidadmedidamasas/Select',configuracion).then(function(response){            
                    masaArray=response.data;
                    masaArray.map(function(x){
                        me.Masa.push({text:x.nombre,value:x.idunidadmasa,idclave:x.idclave});
                    });
                }).catch(function(error){
                    console.log(error);
                });
                axios.get('api/Usuarios/SelectReportSC',configuracion).then(function(response){
                  usuariosarray=response.data;
                  usuariosarray.map(function(x){
                      me.usuarios.push({text:x.nombre,value:x.idusuario});
                  });            
                }).catch(function(error){
                  console.log(error);
                });
                axios.get('api/Estatus/Select',configuracion).then(function(response){
                  estatusArray=response.data;
                  estatusArray.map(function(x){
                      me.estatus.push({text:x.nombre,value:x.idestatus});
                  });            
                }).catch(function(error){
                console.log(error);
                });
                axios.get('api/Estados/Select',configuracion).then(function(response){
                  estadosArray=response.data;
                  estadosArray.map(function(x){
                      me.estados.push({text:'Select',value:'34'});
                      me.estados.push({text:x.nombre,value:x.idestado});
                      me.editprospecto.idestado = 'Select';
                  });            
                }).catch(function(error){
                console.log(error);
                });
                axios.get('api/Paises/Select',configuracion).then(function(response){
                  paisesArray=response.data;
                  paisesArray.map(function(x){
                      me.paises.push({text:x.nombre,value:x.idpais});
                  });            
                }).catch(function(error){
                console.log(error);
                });
                axios.get('api/Expectativas/Select',configuracion).then(function(response){
                  expectativa=response.data;
                  expectativa.map(function(x){
                      me.expectativas.push({text:x.nombre,value:x.idexpectativa});
                  });            
                }).catch(function(error){
                  console.log(error);
                });
                axios.get('api/Archivos/Select',configuracion).then(function(response){
                  cartas=response.data;
                  cartas.map(function(x){
                    me.archivos.push({text:x.nombre,value:x.idarchivo});
                  });            
                }).catch(function(error){
                  console.log(error);
                });
                axios.get('api/Tipoactividades/Select',configuracion).then(function(response){
                tactividad=response.data;
                tactividad.map(function(x){
                    me.tactividades.push({text:x.nombre,value:x.idtipo_actividad});
                });            
                }).catch(function(error){
                  console.log(error);
                });
      },          
      guardarPrimeractividad() {
      //  var diasSemana = new Array("Lunes","Martes","Miércoles","Jueves","Viernes","Sábado","Domingo");
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        var diaLetras;
        let model=this;
        var prospectos=[];
        var tipoactividad;
        var f = new Date();
        var dia = new Date(model.date)
        var mes;
        var d;        
        diaLetras = model.diasSemana[dia.getDay()];
        if((f.getDate()) <= 9){
          d ='0' + f.getDate()
        }else{
          d =  f.getDate()
        }
        if((f.getMonth()+1) <= 9){
            mes = "0" + (f.getMonth() + 1)
        }else{
          mes = f.getMonth() + 1
        }
        var hoy = f.getFullYear() + "-" + mes + "-" + d;
        if(model.nombrep == "" || model.date == ""){
          model.snackbar = true
          model.text = "Llenar todos los campos obligatorios *"
        }else{
          if(model.date >= hoy){
            if(diaLetras == "Sábado" || diaLetras == "Domingo"){
              model.snackbar = true 
              model.text = 'No puedes agendar actividades en fin de semana'
            }else{
              var n;
              for(n=0; n <= model.prospectossn.length; n++ ){
                if(model.nombrep == model.prospectossn[n].value){
                  axios.post('api/Actividades/Crear',{
                      'idprospecto':model.nombrep,
                      'idasignacion':model.prospectossn[n].idasignacion,
                      'idtipo_actividad':2,
                      'idusuario':this.$store.state.usuario.idusuario,
                      'fechaactividad':model.date,
                    },configuracion).then(function(response){
                      model.limpiar();
                      model.listar();
                      model.getEvents();
                      model.snackbar = true 
                      model.text = 'Actividad Guardada Correctamente'
                      model.dialog = false
                  }).catch(function(error){                                                
                    console.log(error); 
                    model.snackbar = true
                    model.text = error
                  });
                  n = model.prospectossn.length;
                  this.select();
                }
              }
            }
          }else{
            model.snackbar = true
            model.text = "La fecha debe ser mayor o igual a " + this.fechaHoy;
          }
        }
      },
      segundaActividad() {
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        let model=this;
        var prospectos=[];
        var tipoactividad;
        if(model.actividad2 == 3){
          this.segunda = true;
          this.enviarConfirmacion(model.idprospecto);
        }else{
          axios.post('api/Actividades/SegundaActividad',{                
            'idprospecto':model.idprospecto,    
            'idtipo_actividad':model.actividad2,
            'idusuario':this.$store.state.usuario.idusuario,
            'fechaactividad':model.datea2,
          },configuracion).then(function(response){
            model.selectedOpen=false;
            model.limpiar();
            model.listar();
            model.getEvents();
            model.snackbar = true                  
            model.text = 'Actividades Guardadas Correctamente'
          }).catch(function(error){
            console.log(error); 
            model.snackbar = true
            model.text = error
          });
          this.select(); 
        }
      }, 
      completara(id){
        this.idactividad = id;
        this.hreporte = false;
        this.reasignar=false;
        this.completar = true;
        this.NameActividad='Completar Actividad';
      },
      reasignaractividad(id){
        this.reasignar=true;
        this.idactividad = id;
        this.hreporte = false;
        this.completar = false;
        this.NameActividad='Reagendar Actividad';
      },
      cartaPresentacion(id){
        this.hreporte = false;
        this.cartap = true;
        this.NameActividad='Carta de Presentación'; 
        this.listarContacto(id);
      },
      completarActividad(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            this.items = [];
            let model=this;
           
            var diaLetras;
            var diaLetras2;
            var dia = new Date(model.datea)
            var dia2 = new Date(model.datea2)
            diaLetras = model.diasSemana[dia.getDay()];
            diaLetras2 = model.diasSemana[dia2.getDay()];

            if(model.datea <= model.fechastar && model.terminaractividad1 == false ){
                model.snackbar = true                  
                model.text = 'La fecha debe ser mayor a la actividad por completar'
            }else{
              if(diaLetras == "Sábado" || diaLetras == "Domingo" || diaLetras2 == "Sábado" || diaLetras2 == "Domingo"){
                model.snackbar = true                  
                model.text = 'No puedes agendar actividades en fin de semana'
              }else{
                if(model.terminaractividad1 == false){
                  if(model.actividad == 3){
                    this.primera = true;
                    this.enviarConfirmacion(model.idprospecto);
                  }else{
                    axios.put('api/Actividades/Actualizar',{
                      'idactividad':model.idactividad,
                      'idexpectativa':model.expectativa,
                      'reporte':model.reporteactividad,
                      'idprospecto':model.idprospecto,
                      'idtipo_actividad':model.actividad,
                      'idusuario':this.$store.state.usuario.idusuario,
                      'fechaactividad':model.datea
                    },configuracion).then(function(response){
                    if(model.actvidad2 == true){
                        model.segundaActividad();
                    }else{
                      model.selectedOpen=false;
                      model.limpiar();
                      model.listar();
                      model.getEvents();
                      model.snackbar = true                  
                      model.text = 'Actividad Guardada Correctamente'
                    }
                  }).catch(function(error){                                                
                      console.log(error); 
                      model.snackbar = true
                      model.text = error
                  });
                  }                
                }else{
                  this.finalizarActividad();
                }
              }  
            }
      },
      fechahoy(){
        const date = new Date()
        const dateTimeFormat = new Intl.DateTimeFormat('Mx', { year: 'numeric', month: 'long', day: '2-digit' }) 
        const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(date ) 
        this.fechaHoy = `${month} de ${day} del ${year }`;
      },
      enviarConfirmacion(id){
        this.reasignar=false;        
        this.hreporte = false;
        this.completar = false;
        this.confirmarVisita = true;
        this.NameActividad='Confirmación de visita';        
        this.listarContacto(id);
      },
      ConfirmacionEnviada(){
        this.confirmarVisita = false;
        
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        this.items = [];
        let model=this;

        axios.put('api/Actividades/Actualizar',{
          'idactividad':model.idactividad,
          'idexpectativa':model.expectativa,
          'reporte':model.reporteactividad,
          'idprospecto':model.idprospecto,
          'idtipo_actividad':model.actividad,
          'idusuario':this.$store.state.usuario.idusuario,
          'fechaactividad':model.datea
        },configuracion).then(function(response){
          if(model.actvidad2 == true){
              model.segundaActividad();
          }else{
            model.selectedOpen=false;
            model.limpiar();
            model.listar();
            model.getEvents();
            model.snackbar = true                  
            model.text = 'Actividad Guardada Correctamente'
          }
        }).catch(function(error){                                                
            console.log(error); 
            model.snackbar = true
            model.text = error
        });
      },
      listarContacto(id){
            var ContactosP = [];
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Contactos/ListarContacto/'+id,configuracion).then(function(response){            
            ContactosP=response.data;
            me.contactos=response.data;
            me.contactosview= response.data;
            ContactosP.map(function(x){
              me.contactosprospecto.push({text:x.correo,value:x.idcontacto})
            });
            }).catch(function(error){
            console.log(error);
            });
      },
      agendarActividad(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            this.items = [];
            let model=this;
            var f = new Date();
            var dia;
            var mes;
            var dia = new Date(model.dateare)
            var diaLetras = model.diasSemana[dia.getDay()];
            if(f.getDate() < 10){
              dia = "0" + f.getDate();
            }else{
              dia = f.getDate();
            }
            if(f.getMonth() < 10){
              mes = "0" + (f.getMonth() + 1);
            }else{
              mes = f.getMonth();
            }


            var hoy =  f.getFullYear() + "-" + mes + "-" + dia ;
            if(model.dateare < hoy){
               model.snackbar = true                  
               model.text = 'La fecha debe ser igual o mayor al dia de hoy'
            }else{
              if(diaLetras == "Sábado" || diaLetras == "Domingo"){
                model.snackbar = true                  
                model.text = 'No puedes agendar actividades en fin de semana'
              }else{
                axios.put('api/Actividades/Reagendar',{
                    'idactividad':model.idactividad,
                    'idtipo_actividad':model.actividadre,                
                    'fechaactividad':model.dateare,
                },configuracion).then(function(response){
                    model.selectedOpen=false;
                    model.limpiar();
                    model.listar();
                    model.getEvents();
                    model.snackbar = true                  
                    model.text = 'Actividad Reagendada Correctamente'
                }).catch(function(error){                                                
                    model.snackbar = true
                    model.text = error
                    console.log(error)
                });
              }
            }
      },
      finalizarActividad(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            this.items = [];
            let model=this;
            axios.put('api/Actividades/TerminarActividad',{
                'idactividad':model.idactividad,
                'idexpectativa':model.expectativa,                
                'reporte':model.reporteactividad,
            },configuracion).then(function(response){
                model.selectedOpen=false;
                model.limpiar();
                model.listar();
                model.getEvents();
                model.snackbar = true                  
                model.text = 'Actividad Terminada Correctamente'
            }).catch(function(error){
                model.snackbar = true
                model.text = error
                console.log(error)
            });
      },
      limpiar(){
        let model=this;  
        model.idactividad = '';
        model.expectativa = '';
        model.reporteactividad = '';
        model.idprospecto = '';
        model.actividad = '';
        model.idnombreu = '';
        model.date = null;
        model.datea = null;
        model.nombrep = '';
        model.terminaractividad1 = false;
      }, 
      noviable(){
        if(this.expectativa == 1 || this.terminaractividad == true){
            this.terminaractividad1 = true;
            this.datea='';
            if(this.expectativa == 1){
              this.actividad = 5;
            }else{
              this.actividad = '';}

        }else{
          this.terminaractividad1 = false;
          this.actividad = '';
        }
      },
      eventRender: function(event, element) {
        if(event.icon){          
            element.find(".pl-1").prepend("<span class='material-icons'>+event.icon+</span>");            
        }
      },
      getEvents(){
        let me = this;//this para que pueda ser utilizada en cualquiier llamado de aacion         
        let header={"Authorization" : "Bearer " + me.$store.state.token};        
        let configuracion ={headers:header};
        me.events = [];
        var events = []
        var inactivo = false;
        var ultimaatividad = false;
        me.hoy = new Date();
        this.items = [];
        var fechaincompleta;
        me.dialodload = true;
        axios.get('api/Actividades/ListarActividadUs/' + me.idusuarioselect,configuracion).then(function(response){
            events=response.data;
           //Array Con dias de la semana
            var diasSemana = new Array("Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado");  
            events.map(function(x){
                  var diaLetras;
                  var day;
                  var fecha1;
                  var diasDif;
                  var dias;

                  day = new Date(x.fechaactividad1);
                  //---------------------Sacamos Rango de dias transcurridos entre el dia de la actividad y el dia actual----------------------------------
                  fecha1 = new Date(x.fechaactividad1.substring(0,4),x.fechaactividad1.substring(5,7)-1,x.fechaactividad1.substring(8,10));
                  diasDif = me.hoy.getTime() - fecha1.getTime();
                  dias = Math.round(diasDif/(1000 * 60 * 60 * 24));

                  //-----------------------------------------------------------------------------------------------------------------------------------------
                    diaLetras = diasSemana[day.getDay()+1];

                    if(x.completada == false){
                      x.color = '#fd1100 !important';
                      x.colort = 'rgb(165 14 3) !important';
                      if(dias > 2){
                        if(diaLetras == 'Viernes'){
                          if(dias >= 4){
                            inactivo=true;
                          }
                        }else{
                          inactivo=true;
                        }
                      }else{
                        if(dias <= 0){
                          x.color= 'rgb(255, 129, 91) !important';
                        }
                      }
                    }else{
                      if(x.idtipo_actividad == 5){
                        x.color = '#000000 !important';
                        x.colort = 'rgb(0,0,0) !important';
                      }else{
                        x.color='rgb(15,114,193) !important';
                        x.colort='rgb(4,158,94) !important';
                      }
                    }              
                  me.events.push({
                    idactividad:x.idactividad,
                    idprospecto:x.idprospecto,
                    icon:x.icono,
                    name:x.nombrep,
                    nombreus:x.nombreus,
                    start:x.fechaactividad1,
                    color:x.color,
                    colort:x.colort,
                    tipoactividad:x.idtipo_actividad,
                    nactividad:x.nactividad
                  });
          });
            me.dialodload = false;
            me.reporteventas(me.idusuarioselect)
        }).catch(function(error){
            console.log(error);
            me.dialodload = false;
        });
        this.start =  events.fechaactividad;
      },
      getEventColor (event) {       
        return event.color
      },
      setToday () {
        this.focus = this.today
      },
      prev () {        
        this.$refs.calendar.prev()
      },
      next () {        
        this.$refs.calendar.next()
      },
      informacionsolicitud(id,clave){
        let me = this;//this para que pueda ser utilizada en cualquiier llamado de aacion         
        let header={"Authorization" : "Bearer " + me.$store.state.token};        
        let configuracion ={headers:header};

        me.starifa = [];
        me.nstatus = '';
        me.noperacion = '';
        me.basis = '';
        me.ntipoembarque = '';
        me.nrecoleccion = '';
        me.npickup = '';
        me.npol = '';
        me.npod = '';
        me.ndelivery = '';
        me.nentrega = '';
        me.nfoodgrade = '';
        me.ncustoms = '';
        me.ninsurance = '';
        me.nvgm = '';
        me.nmaneuvers = '';
        me.ncustody = '';
        me.nobservaciones = '';
        me.nmercancia = '';
        me.viewsta = false;
        me.viewcot = false;
        me.ncotizaciones = '';
        var CotizacionesDatos = '';
        me.detalleinfo = '';

        var starifa = [];
        if(clave == 'COT' || clave == 'ATC'){
          console.log('Entra cotizacion')
            me.detalleinfo = 'Detalles de la Cotizacion';
             me.viewcot = true;
             axios.get('api/Cotizaciones/ListarInfoCot/'+ id,configuracion).then(function(response){                
                CotizacionesDatos = response.data;
                CotizacionesDatos.map(function(x){
                  me.nstarifa = x.ncotizacion;
                  me.nmodalidad = x.modalidad;
                  me.nmovimiento = x.movimiento;
                  me.nproducto = x.producto;
                  me.norigen = x.origen;
                  me.ndestino = x.destino;
                  me.nservicio = x.servicio;
                  me.nvia = x.via;
                  me.ntransbordo = x.transbordo;
                  me.ntt = x.tt;
                  me.nbody = x.body;
                });
                me.tarifasenviadas(id);
                me.listarconceptos(id);
                me.loadingS = false;
                me.DialogStarifa = true;
            }).catch(function(error){
                me.loadingS = false;
                console.log(error);
            });
        }
        if(clave == 'SLC'){
          me.viewsta = true;
          me.detalleinfo = 'Detalles de Solicitud de Tarifa';
          axios.get('api/Scotizaciones/Listar/'+ id,configuracion).then(async function(response){
            starifa = response.data;
            console.log('starifa')
            console.log(starifa)
            me.loadingS = false;
            me.DialogStarifa = true;
            starifa.map(function(x){

              me.nstatus = x.status;
              me.noperacion = x.tipoOp;
              me.basis = x.basis;
              me.nrecoleccion = x.direccionreceipcompleta;
              me.npickup = x.npuertoreceipt;
              me.npol = x.npuertoloading;
              me.npod = x.npuertodischarge;
              me.ndelivery = x.npuertodelivery;
              me.nentrega = x.direcciondeliverypcompleta;
              me.nfoodgrade = x.foodgrade;
              me.nobservaciones = x.remarks;
              me.nmercancia = x.comodity;
              me.nstarifa = x.ncotizacion;

              if(x.custom == true){
                me.ncustoms = 'SI';
              }
              if(x.insurance == true){
                me.ninsurance = 'SI';
              }
              if(x.vgm == true){
                me.nvgm = 'SI';
              }
              if(x.maneuvers == true){
                me.nmaneuvers = 'SI';
              }
              if(x.custody == true){
                me.ncustody = 'SI';
              }

              if(x.basis == 'FTL' || x.basis == 'LTL'){
                me.ntipoembarque = 'TERRESTRE';
              }
              if(x.basis == 'FCL' || x.basis == 'LCL'){
                me.ntipoembarque = 'MARITIMO';
              }
              if(x.basis == 'AEREO'){
                me.ntipoembarque = 'AEREO';
              }
              if(x.hazardous == true){
                me.harz = 'SI';
              }else{
                me.harz = 'NO';
              }
              me.starifa.push({
                  status:x.status,
              });
              if(x.idbasis == 2 || x.idbasis == 4 || x.idbasis == 5){
                  me.ListarPackage(x.idscotizacion,x.idbasis);
              }else{
                  me.cargarContainer(x.idscotizacion);
              }
            });
            var ncotizacion= [];
            var nc = '';
            axios.get('api/Cotizaciones/ListarNcotizacioN/'+ id,configuracion).then(function(response){
                ncotizacion = response.data;
                ncotizacion.map(function(y){
                  if(nc == ''){
                    nc = nc + y.ncotizacion
                  }else{
                    nc = nc + ', '+ y.ncotizacion
                  }
                })
                me.ncotizaciones = nc;
              }).catch(function(error){
                  console.log(error);
              });
            }).catch(function(error){
              me.loadingS = false;
                console.log(error);
            });
        }
      },
      tarifasenviadas(id){
          let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
          let header={"Authorization" : "Bearer " + this.$store.state.token};
          let configuracion ={headers:header};
          var ArrayCostos = [];
          var subtotal = 0;
          var iva = 0;
          var niva = 0;
          var total = 0;
          me.costos = [];
          me.subtotalusd = 0;
          me.ivausd = 0;
          me.totalusd = 0;
          me.nsubtotalusd = 0;
          me.nivausd = 0;
          me.ntotalusd = 0;
          me.subtotalmxn = 0;
          me.ivamxn = 0;
          me.totalmxn = 0;
          me.nsubtotalmxn = 0;
          me.nivamxn = 0;
          me.ntotalmxn = 0;
          axios.get('api/Tarifas_Cotizaciones/ListarTarifascotizacionusuarios/'+ id ,configuracion).then(function(response){                
              ArrayCostos=response.data;
              ArrayCostos.map(function(x){
                  subtotal = 0;
                  niva = 0;
                  total = 0;
                  if(x.idcostopor == 1 || x.idcostopor == 3 || x.idcostopor == 4){
                      subtotal = x.costounitario * x.cantidad;
                  }
                  if(x.idcostopor == 2 || x.idcostopor == 5){
                      subtotal = Number(x.costounitario);
                  }
                  if(x.iva == 1){
                      niva = subtotal * 0.16;
                      iva = 1;
                  }else{
                      iva = false;
                  }
                  total = (niva + subtotal);
                  if(total == NaN){
                      total = 0;
                  }
                  if(subtotal == NaN){
                      subtotal = 0;
                  }
                  if(x.moneda == 'USD'){
                      me.subtotalusd = me.subtotalusd + subtotal;
                      me.ivausd = me.ivausd + niva;
                      me.totalusd = me.totalusd + total;
                      me.nsubtotalusd = me.addCommas(parseFloat(me.subtotalusd).toFixed(2));
                      me.nivausd = me.addCommas(parseFloat(me.ivausd).toFixed(2))
                      me.ntotalusd = me.addCommas(parseFloat(me.totalusd).toFixed(2))
                      me.activousd = true;
                  }
                  if(x.moneda == 'MXN'){
                      me.subtotalmxn = me.subtotalmxn + subtotal;
                      me.ivamxn = me.ivamxn + niva;
                      me.totalmxn = me.totalmxn + total;
                      me.nsubtotalmxn = me.addCommas(parseFloat(me.subtotalmxn).toFixed(2));
                      me.nivamxn = me.addCommas(parseFloat(me.ivamxn).toFixed(2));
                      me.ntotalmxn = me.addCommas(parseFloat(me.totalmxn).toFixed(2));
                      me.activomxn = true;
                  }
                    me.costos.push({ 
                      idtarifascot:x.idtarifascot,
                      idcostopor:x.idcostopor,
                      concepto: x.concepto,
                      costopor: x.costopor,
                      cantidad: x.cantidad,
                      costounitario: x.costounitario,
                      ncostounitario:me.addCommas(x.costounitario),
                      idmoneda: x.idmoneda,
                      moneda: x.moneda,  
                      iva:x.iva,
                      ivas:x.iva,
                      niva:niva,
                      nniva:me.addCommas(parseFloat(niva).toFixed(2)),
                      subtotal:subtotal,
                      nsubtotal:me.addCommas(parseFloat(subtotal).toFixed(2)),
                      total:total,
                      ntotal:me.addCommas(parseFloat(total).toFixed(2)),
                      activo:true
                  });
              });
          }).catch(function(error){
              console.log(error);
          });
      },
      cargarremarks(){
          this.RemarksCotizacion = [];
          var remarkfcl = [];
          if(this.$store.state.usuario.rol == 'PricingAgente' || this.$store.state.usuario.rol == 'ComercialAgente'){
              remarkfcl.push(
                  {text:'No maneuvers on Airport/Port included, this must be pay by the customs agent.',value:1},
                  {text:'All inlands are quoted in tandem ( 2 container per truck)',value:2},
                  {text:'No customs maneuvers.',value:3},
                  {text:'No custom storage included.',value:4},
                  {text:'No inspections included.',value:5},
                  {text:'No insurance included (0.7% over cargo value if needed)',value:6},
                  {text:'No custody included.',value:7},
                  {text:'No unloading/loading maneuvers included',value:8},
                  {text:'Free unloading time',value:9},
                  {text:'Rate base on the information given.',value:10},
                  {text:'Otro.',value:16}
              );
          }else{
              remarkfcl.push(
                  {text:'Costos libres de maniobras.',value:1},
                  {text:'horas libres de carga.',value:2},
                  {text:'horas libres de descarga.',value:3},
                  {text:'días de crédito.',value:4},
                  {text:'Sujeto a disponibilidad de espacio y equipo.',value:5},
                  {text:'Incluye Carta Garantía.',value:6},
                  {text:'Los tiempos de tránsito son estimados. ',value:7},
                  {text:'Terrestre dentro de BL en servicio Full.',value:8},
                  {text:'Terrestre dentro de BL en servicio Sencillo.',value:9},
                  {text:'días libres de demoras en origen.',value:10},
                  {text:'días libres de demoras en destino.',value:11},
                  {text:'Costos para carga peligrosa.',value:12},
                  {text:'Costos para carga No peligrosa.',value:13},
                  {text:'Incluye gastos locales en origen.',value:14},
                  {text:'No incluye seguro (opcional: 0.6% + iva sobre valor factura).',value:15},
                  {text:'Otro.',value:16}
              );
          }
          this.RemarksCotizacion = remarkfcl;
      },
      listarconceptos(idcotizacion){
        let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        var ArrayObservaciones = [];
        var RemarksCotizacion = '';
        me.remarkstextc = [];
        axios.get('api/ObservacionesCotizacions/Listarcotizacionusuarios/'+ idcotizacion ,configuracion).then(function(response){                
            ArrayObservaciones=response.data;
            ArrayObservaciones.map(function(x){
                if(x.idremark > 0){
                    RemarksCotizacion = me.RemarksCotizacion[x.idremark - 1].text;
                }else{
                    RemarksCotizacion = '';
                }
                var comentario='';
                if(x.observacion == ''){
                    comentario = RemarksCotizacion;
                }
                else{
                    comentario = x.observacion + " " + RemarksCotizacion;
                }
                me.remarkstextc.push({
                    idobs:x.idobs,
                    text: comentario,
                    idremarktext: RemarksCotizacion,
                    observacion: x.observacion,
                    idremark: x.idremark,
                    activo:true
                });
            });
            if(me.remarkstextc.length > 0){
                me.remarksview = true;
            }else{
                me.remarksview = false;
            }
        }).catch(function(error){
            console.log(error);
        });
      },
      ListarPackage(idbs,idbasis){
            var datospackage = [];
            this.addpackages = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;
            axios.get('api/Packages/ListarPackage/' + idbs,configuracion).then(function(response){                            
                datospackage=response.data;
                datospackage.map(function(x){
                    var pwidth = 0;
                    var plarge = 0;
                    var phigh = 0;
                    var weight = 0;
                    var pesovolumetrico = 0;
                    var pesovolcompleto = 0;
                    if(x.idlongitud== 4 ){ //Centimetros a Metros
                        plarge = parseFloat(x.large / 100).toFixed(2);
                        pwidth = parseFloat(x.width/ 100).toFixed(2);
                        phigh = parseFloat(x.high / 100).toFixed(2);
                    }

                    if(x.idlongitud == 2){ //Pies a Metros
                        plarge = parseFloat(x.large / 3.28084).toFixed(2);
                        pwidth = parseFloat(x.width / 3.28084).toFixed(2);
                        phigh = parseFloat(x.high / 3.28084).toFixed(2);
                    }
                    if(x.idlongitud == 3){ //Pies a Metros
                        plarge = parseFloat(x.large / 39.3701).toFixed(2);
                        pwidth = parseFloat(x.width / 39.3701).toFixed(2);
                        phigh = parseFloat(x.high / 39.3701).toFixed(2);
                    }
                    if(x.idlongitud == 1){
                        plarge = x.large;
                        pwidth = x.width;
                        phigh = x.high;
                    }
                     if(x.idpeso == 1){//Toneladas a Kilogramos
                        weight = x.weight; 
                    }
                    if(x.idpeso == 2){//Toneladas a Kilogramos
                        weight = parseFloat(x.weight * 1000).toFixed(2); 
                    }
                    if(x.idpeso == 4){//Libras a Kilogramos
                        weight = parseFloat(x.weight * 0.453592).toFixed(2); 
                    }
                    if(x.idpeso == 5){//Libras a Kilogramos
                        weight = parseFloat(x.weight / 1000).toFixed(2); 
                    }
                    
                    if(idbasis == 5){
                        pwidth = pwidth * 100;
                        plarge = plarge* 100;
                        phigh = phigh * 100;
                        pesovolumetrico = parseFloat(((pwidth * plarge) * phigh) / 6000).toFixed(2);
                        pesovolumetrico =parseFloat(pesovolumetrico * x.quantity).toFixed(2);
                       // me.volumenwn = parseFloat(Number(me.volumenwn) + Number(pesovolumetrico)).toFixed(2);
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Kg.';
                    }else{
                        pesovolumetrico = parseFloat(((pwidth * plarge) * phigh)).toFixed(2);
                        pesovolumetrico = pesovolumetrico * x.quantity;
                       // me.volumenwn = parseFloat(Number(me.volumenwn) + Number(pesovolumetrico)).toFixed(2);
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Ton.';
                    }
                    
                    var nstackable;
                    var actualweight = x.quantity * weight;
                   // me.totalwn = parseFloat(Number(me.totalwn) + Number(actualweight)).toFixed(2);
                    if(x.stackable == true){
                        nstackable = 'yes'
                    }else{
                        nstackable = 'no'
                    }
                    me.addpackages.push({
                        idspackage:x.idspackage,
                        idpackage:x.idpackage,
                        longitud:'',
                        idlongitud:x.idlongitud,
                        idpeso:x.idpeso,
                        stackable:x.stackable,
                        nstackable:nstackable,
                        weight:x.weight,
                        nweight:parseFloat(weight).toFixed(2) + ' Kg.',
                        high:x.high,
                        width:x.width,
                        large:x.large,
                        nhigh:phigh + ' Mts.',
                        nwidth:pwidth + ' Mts.',
                        nlarge:plarge + ' Mts.',
                        volumetricweight:pesovolcompleto,
                        actualweight:parseFloat(actualweight).toFixed(2) + ' Kg.',
                        nactualweight:actualweight,
                        quantity:x.quantity,
                        package:x.tnpackage,
                        Notes:x.notes,
                        otropackage:x.otropackage,
                        pesovolumetrico:pesovolumetrico,
                        activo:x.activo,
                    })
                })
            }).catch(function(error){
            console.log(error);
            });
      },
      cargarContainer(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var containerarray = [];
            me.containers = [];
            axios.get('api/DatosContainerUnits/ListarContainers/'+ id,configuracion).then(function(response){
                containerarray=response.data;
                var totalw = 0;
                var nweight
                var weight = 0;;
                containerarray.map(function(x){
                    
                    nweight = parseFloat(x.nweight).toFixed(2);
                    var indexmasa = 0;
                    var peso = 0;
                    indexmasa = me.Masa.findIndex(y=>y.value == x.idunidadmasa);
                    //peso = me.editcontainer.peso;
                    var idmasa = me.Masa[indexmasa].idclave;

                    if(idmasa == 'KL1'){//Toneladas a Kilogramos
                        weight = parseFloat(x.weight).toFixed(2); 
                    }
                    if(idmasa == 'TN1'){//Toneladas a Kilogramos
                        weight = parseFloat(x.weight * 1000).toFixed(2); 
                    }
                    if(idmasa == 'GR1'){//Gramos a Kilogramos
                        weight = parseFloat(x.weight / 1000).toFixed(2); 
                    }
                    if(idmasa == 'LI1'){//Libras a Kilogramos
                        weight = parseFloat(x.weight * 0.453592).toFixed(2); 
                    }

                    totalw = totalw + weight;
                    me.containers.push({
                        idcontainer:x.idcontainer,
                        quantity:x.quantity,
                        size:x.size,
                        idsize:x.idsize,
                        type:x.type,
                        idtype:x.idtype,
                        weight:x.weight,
                        nweight:me.addCommas(parseFloat(weight).toFixed(2)) +' Kg.',
                        totalweight:me.addCommas(parseFloat(totalw).toFixed(2)) + ' Kg.',
                        remarks:'',
                        idunidadmasa:x.idunidadmasa,
                        activo:x.activo
                    })
                });
            }).catch(function(error){
                console.log(error);
            });
      },
      showEvent ({ nativeEvent, event }) {
        this.limpiar();
        this.hreporte = true;      
        this.completar = false;
        this.cartap = false;  
        this.reasignar = false;
        this.terminaractividad = false;
        this.actvidad2 = false;
        this.confirmarVisita = false;
        this.viewdata = false;
        this.NameActividad='Historial de Reportes';
        var actividades = [];
        this.ncompletada = 0;
        var reportes=[]; 
        this.items = [];
        
        let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        this.fechastar = event.start;
        this.ncustumer = event.name;
            axios.get('api/Actividades/ListarActividad/'+event.idprospecto,configuracion).then(function(response){            
              actividades=response.data;     
              actividades.map(function(x){
                if(x.completada == false){
                  me.ncompletada = me.ncompletada + 1;
                } 
                me.items.push({
                  idactividad:x.idactividad,
                  idprospecto:x.idprospecto,
                  nombrea:x.nombrea,
                  icono:x.icono,
                  idexpectativa:x.idexpectativa,
                  expectativa:x.expectativa,
                  idusuario:x.idusuario,
                  nombreus:x.nombreus,
                  reporte:x.reporte,
                  iddocumento:x.iddocumento,
                  fechaactividad1:x.fechaactividad1,
                  clave_actividad:x.clave_actividad,
                  reagendaractividad:x.reagendaractividad,
                  completada:x.completada,
                  tipoactividad:x.idtipo_actividad
                })
              })
          }).catch(function(error){
              console.log(error);
          });
        const open = () => {
          this.selectedEvent = event          
          setTimeout(() => this.selectedOpen = true, 10)
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }
        this.idprospecto  = event.idprospecto;

        nativeEvent.stopPropagation()
      },
      nth (d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      formatDate (a, withTime) {
        return withTime
          ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
          : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
      },
      remove (item) {
        const index = this.friends.indexOf(item.name)
        if (index >= 0) this.friends.splice(index, 1)
      },
      name(){
        return this.$store.state.usuario.nombre;
      },
      enviarcorreocp(){
            let loader = Vue.$loading.show({color: '#189bec',loader: 'spinner'});
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};[];
            let model=this;
            axios.post('api/Actividades/EnviarMailCarta',{
              asunto:model.cpasunto,
              idusuario:model.$store.state.usuario.idusuario,
              contenido:model.editorcp,
              contactos:model.contactoscp,
              archivos:model.adjuntararchivo
            },configuracion).then(function(response){
                  loader.hide()
                  model.selectedOpen=false;
                  model.limpiar();
                  model.listar();
                  model.getEvents();
                  model.snackbar = true 
                  model.text = 'Correo enviado correctamente'
            }).catch(function(error){
                loader.hide()                                                
                console.log(error); 
                model.snackbar = true
                model.text = error
            });
      },
      enviarcorreoprueba(){
        let loader = Vue.$loading.show({color: '#189bec',loader: 'spinner'});
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};[];
        let model=this;
        
        axios.post('api/Actividades/EnviarMail',{
          asunto:"Confirmacion de Visita a "+ model.ncustumer + " el dia " + model.datea,
          fecha:model.datea,
          contenido:model.contenido,
          prospecto:model.ncustumer,
          idusuario:model.$store.state.usuario.idusuario,
          contactos:model.contactos,
          contactoscc:model.contactoscc
        },configuracion).then(function(response){
              model.dialog = false
            if(model.primera == true){
              axios.put('api/Actividades/Actualizar',{
                'idactividad':model.idactividad,
                'idexpectativa':model.expectativa,
                'reporte':model.reporteactividad,
                'idprospecto':model.idprospecto,
                'idtipo_actividad':model.actividad,
                'idusuario':model.$store.state.usuario.idusuario,
                'fechaactividad':model.datea
              },configuracion).then(function(response){
              if(model.actvidad2 == true){
                loader.hide()
                model.segundaActividad();
              }else{
                loader.hide()
                model.selectedOpen=false;
                model.limpiar();
                model.listar();
                model.getEvents();
                model.snackbar = true                  
                model.text = 'Actividad Guardada Correctamente'
              }
              }).catch(function(error){      
                  loader.hide();
                  model.snackbar = true
                  model.text = error
                  console.log(error)
              });
            }
            if(model.segunda == true){
              axios.post('api/Actividades/SegundaActividad',{
                'idprospecto':model.idprospecto,    
                'idtipo_actividad':model.actividad2,
                'idusuario':model.$store.state.usuario.idusuario,
                'fechaactividad':model.datea2,
              },configuracion).then(function(response){
                loader.hide() 
                model.selectedOpen=false;
                model.limpiar();
                model.listar();
                model.getEvents();
                model.snackbar = true                  
                model.text = 'Actividades Guardadas Correctamente'
              }).catch(function(error){
                console.log(error);
                loader.hide()
                model.snackbar = true
                model.text = error
              });
              this.select();
            }
        }).catch(function(error){    
            loader.hide()
            console.log(error); 
            model.snackbar = true
            model.text = error +  " Fallo el envio de correo de confirmación"
        });
      },
      editarprospecto(item) {
        var prospecto=[];
           let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
          let header={"Authorization" : "Bearer " + this.$store.state.token};
          let configuracion ={headers:header};
          axios.get('api/Prospectos/Buscar/' + item,configuracion).then(function(response){
              prospecto=response.data;
              me.listarContacto(item);
              me.dialogp = true 
          }).catch(function(error){
              console.log(error);
          });
        
          
      },
      guardarprospecto(){

      },
      editItemc (item) {
          this.editedIndex = this.contactos.indexOf(item)
          this.editcontact = Object.assign({}, item)
      },
      activarDesactivarMostrar(accion,item){
           this.adModal=true;
           this.adNombre=item.nombre;
           this.adId=item.idprospecto;
            if(accion==1)
            {
                this.adAccion=1;                
            }
            else if(accion==2){
                this.adAccion=2;
            }
            else{
                this.adModal=false;
            }
      },
      activarestado(){
          if(this.editprospecto.idpais == 1){
              this.editprospecto.idestado = false;
          }else{
              this.editprospecto.idestado = false;
          }
      },
      agregar(){         
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;

            if(model.editcontact.nombre === '' || model.editcontact.correo === ''){        
                model.adModalcontact = true;
            }else
            {
                 if (model.editedIndexp > -1) {
                     if (model.editedIndex > -1) {
                        Object.assign(model.contactos[model.editedIndex], model.editcontact)    
                        axios.put('api/Contactos/Actualizar',{
                            'idcontacto': model.editcontact.idcontacto,                            
                            'nombre': model.editcontact.nombre,
                            'puesto' : model.editcontact.puesto,                    
                            'telefono' : model.editcontact.telefono,
                            'celular' : model.editcontact.celular,
                            'correo' : model.editcontact.correo,
                            'idpropietario' : model.editprospecto.idprospecto
                        },configuracion).then(function(response){                                                                       
                            model.editedIndex = -1;                            
                            model.limpiar();
                            model.snackbar = true;
                            model.mensaje = 'Contacto Actualizado'                                                      
                        }).catch(function(error){
                            console.log(error);
                        });  

                    } else {  
                        model.contactos.push({
                            nombre:model.editcontact.nombre,
                            puesto:model.editcontact.puesto,
                            telefono:model.editcontact.telefono,
                            celular:model.editcontact.celular,
                            correo:model.editcontact.correo,
                            activo:1
                        })                      
                         axios.post('api/Contactos/Crear',{
                            'nombre': model.editcontact.nombre,
                            'puesto' : model.editcontact.puesto,                    
                            'telefono' : model.editcontact.telefono,
                            'celular' : model.editcontact.celular,
                            'correo' : model.editcontact.correo,
                            'propietario' : 'pros',
                            'idpropietario' : model.editprospecto.idprospecto
                        },configuracion).then(function(response){                                  
                            model.limpiar();
                            model.snackbar = true;
                            model.mensaje = 'Contacto guardado  ' 
                        }).catch(function(error){                                                
                            console.log(error); 
                        });                                      
                    }                    
                }
                else{
                    if (model.editedIndex > -1) {
                        Object.assign(model.contactos[model.editedIndex], model.editcontact)
                        model.editedIndex = -1;
                    } else {                        
                        model.contactos.push({
                            nombre:model.editcontact.nombre,
                            puesto:model.editcontact.puesto,
                            telefono:model.editcontact.telefono,
                            celular:model.editcontact.celular,
                            correo:model.editcontact.correo,
                            activo:1
                        })
                        model.limpiar();  
                    }
                }
            }
      },
      AliminarA(item){
        let me=this;
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        axios.put('api/Actividades/Desactivar/'+item.idactividad,{},configuracion).then(function(response){
            window.alert('Actividad Eliminada')
            me.selectedOpen = false;
            me.getEvents();
        }).catch(function(error){
            console.log(error);
        });
      },
      CompletarA(item){
        let me=this;
        let header={"Authorization" : "Bearer " + this.$store.state.token};
        let configuracion ={headers:header};
        axios.put('api/Actividades/ActividadCompletada/'+item.idactividad,{},configuracion).then(function(response){
            window.alert('Actividad Completada')
            me.selectedOpen = false;
            me.getEvents();
        }).catch(function(error){
            console.log(error);
        });
      },
      async reporteventas(idus){
        this.totalprofit = 0;
        this.tprofit = 0;
        this.porsentajecumplido = 0;
        this.finicio = null;
        this.ffin = null;
        this.ntarget = 0;
       /* if(this.$store.state.usuario && this.$store.state.usuario.rol === 'Comercial' || this.$store.state.usuario && this.$store.state.usuario.rol === 'ComercialAdmin' || this.$store.state.usuario && this.$store.state.usuario.rol === 'PricingTerrestre' || 
          this.$store.state.usuario && this.$store.state.usuario.rol === 'PricingAgente' || this.$store.state.usuario && this.$store.state.usuario.rol === 'ComercialAgente'
          || this.$store.state.usuario && this.$store.state.usuario.rol === 'Pricing')
          {*/
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var arrayTarget = [];
            await axios.get('api/targets/Select/' + idus,configuracion).then(async function(response){
              arrayTarget=response.data;
              arrayTarget.map(function(x){
                me.ntarget = x.rate;
                me.finicio = x.vigenciainicio;
                me.ffin = x.vigenciafin;
              });
            }).catch(function(error){
              console.log(error);
            });
            if(me.finicio != null && me.ffin != null){
              await axios.get('api/Buysells/ReporteTarget/' + idus + '/' + me.finicio + '/' + me.ffin,configuracion).then(async function(response){                
                  me.BuySellLista = response.data;
                  await me.total();
              }).catch(function(error){
                  console.log(error);
              });
            }
         // }
      },
      total(){  
        console
        for(var i = 0; i < this.BuySellLista.length; i++){
          this.totalprofit = this.totalprofit + this.BuySellLista[i].profitt;
        }
      },
      PromedioVenta(){
        this.porsentajecumplido = (this.totalprofit / this.ntarget) * 100;
        if(this.porsentajecumplido <= 50 ){
          this.ncolor="rgb(255,17,0)";
        }
        if(this.porsentajecumplido > 50 && this.porsentajecumplido <= 75){
          this.ncolor="#2196f3";
        }
        if(this.porsentajecumplido > 75 ){
          this.ncolor="#4caf50";
        }
        return this.porsentajecumplido;
      },
      addCommas(nStr) {
          nStr += '';
          var x = nStr.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
              x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }
          return x1 + x2;
      },
    },
  }
</script>